webpackJsonp([1],{

/***/ 215:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAzNiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjE4NDI0IDE2Ljk0MjVMMi42Nzk1NyAxNC4yNUgzNS40NDc4VjEyLjc1SDIuNjc5NTdMNS4xODQyNCAxMC4wNTc1TDQuMTk3NzYgOUwwIDEzLjVMNC4xOTc3NiAxOEw1LjE4NDI0IDE2Ljk0MjVaTTM1LjQ0NzggNC41TDMxLjI1IDBMMzAuMjYzNSAxLjA1NzVMMzIuNzY4MiAzLjc1SDBWNS4yNUgzMi43NjgyTDMwLjI2MzUgNy45NDI1TDMxLjI1IDlMMzUuNDQ3OCA0LjVaIiBmaWxsPSIjOUVBN0I2Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ2LjY4OTkgNUg0Ni4yODQ1TDM4LjIzMTYgMjMuMDgzN0gzOS4yMzE0TDQ2LjQ3MzcgNi43NDIzN0w1My42NjE5IDIzLjA4MzdINTQuNzE1OEw0Ni42ODk5IDVaIiBmaWxsPSIjOTFCRTIzIi8+CjxwYXRoIGQ9Ik0xMi45NjY5IDVDOC4zNTI2MSA1IDQuNDE3MzQgNy44ODUwMiAyLjg4MzM4IDExLjkzNzhDMy4yNzc0IDEwLjkzMjYgMy44ODQ1NCA5LjkxNTEzIDQuNjk5ODUgOS4xMDIxQzcuODYxOTQgNS45NTgzOSAxMi45ODY3IDUuOTU4MzkgMTYuMTQ4OCA5LjEwMjFDMTcuNTAxOSAxMC40NDczIDE4LjI5OTggMTIuMTY5NCAxOC4zNTE5IDEzLjkyMTFDMTguMzUxOSAxNS4zMTMxIDE3LjgyOSAxNi41NzcgMTYuOTU0MiAxNy41MjhMMTYuODMyOCAxNy42NDg4TDEyLjk2NjkgMjEuNDkyMkwzLjk4MzY3IDMwLjQyMzJDMi4xMTc2NCAzMi41MjQ3IDEgMzUuMjkzOSAxIDM4LjMxMkMxIDQ0Ljc0OTcgNi4xNDQ2IDQ5Ljk5IDEyLjU3MDQgNTAuMTk5NUMxMC42MzI1IDUwLjEwNTggOC43MzY3MiA0OS4zMTAxIDcuMjQyNDEgNDcuODUxNUM0LjU4MzM4IDQ1LjI1NzIgMy42NDE2OSAzOS44NDQ0IDcuMTExMDcgMzYuNjAyMkwyMC41NTQ5IDIzLjMwM0MyMC41OTk1IDIzLjI1ODYgMjAuNjQ2NiAyMy4yMTY4IDIwLjY4ODcgMjMuMTcyNEMyMC45Njg4IDIyLjg4NjYgMjEuMjMxNSAyMi41ODYxIDIxLjQ3OTMgMjIuMjcwN0MyMi44OTQzIDIwLjQ1NzQgMjMuNzM2OCAxOC4xODA5IDIzLjczNjggMTUuNzA5OEMyMy43MzY4IDkuNzk0NCAxOC45MTQ0IDUgMTIuOTY2OSA1WiIgZmlsbD0iIzMzOEZGRiIvPgo8cGF0aCBkPSJNNS43NjI5NyA0Mi42MzgyQzYuMDI1NjUgNDMuMjczOSA2LjQxNzIgNDMuODY3NiA2LjkzNTEzIDQ0LjM4NUM5LjAzOTA2IDQ2LjQ3NjcgMTIuNDAxOSA0Ni40MDA0IDE0LjUwNTggNDQuMzA4N0wyOC4zNDYyIDMwLjU5NTZDMzAuMjc2NiAyOC43NyAzMi44MzE2IDI3LjYwNDYgMzUuNzA2MiAyNy42MDQ2QzM3LjE1MzQgMjcuNjA0NiAzOC41MzEzIDI3Ljg4NzkgMzkuNzkyNyAyOC40MDI5QzQwLjY5NDcgMjguNzk0NiA0MS41OTQzIDI5LjQwODEgNDIuMzMyNyAzMC4xNDIyQzQ1LjQ5NDggMzMuMjg2IDQ1LjQ5NDggMzguMzgwOSA0Mi4zMzI3IDQxLjUyNDZDNDEuNTU5NiA0Mi4yOTMzIDQwLjc4NjQgNDIuODI1NSAzOS44MzQ4IDQzLjIxNzJDNDEuNjkwOSA0Mi4zNzIyIDQyLjk2NDcgNDAuNDcyNiA0Mi45NjQ3IDM4LjMxMkM0Mi45NjQ3IDM1LjM1NTUgNDAuNTUzNCAzMi45NTgzIDM3LjU3OTcgMzIuOTU4M0MzNi4yNTg4IDMyLjk1ODMgMzUuMDA0OSAzMy4zOTQ0IDM0LjA2ODIgMzQuMTgwM0wyMS41MDkgNDYuNjQ5MkMxOS4zMzgyIDQ4Ljg0NjggMTYuMzE0OSA1MC4yMDkzIDEyLjk3MTkgNTAuMjA5M0MxMC45MDAxIDUwLjIwOTMgOC44Mjg0MiA0OS40MjMzIDcuMjQ3MzcgNDcuODUxNUM0LjI5NTkyIDQ0LjkxNzIgNC4wOTAyMyAzOS44Mzk1IDYuNTk1NjIgMzcuMTQxN0M2LjU5NTYyIDM3LjE0MTcgNi42ODczMSAzNy4wMjg0IDYuNTk1NjIgMzcuMTQxN0M1LjM1NjU2IDM4LjY4NjQgNS4wMTcwNSA0MC43ODU1IDUuNzYyOTcgNDIuNjM4MloiIGZpbGw9IiMwNDU1QzYiLz4KPHBhdGggZD0iTTE4LjAzOTcgMTIuMTM5OUMxNy4yOTg3IDEwLjA2MDUgMTUuMzExMiA4LjU2OTk4IDEyLjk2NjkgOC41Njk5OEM5Ljk5MzE4IDguNTY5OTggNy41ODE5NiAxMC45NjcyIDcuNTgxOTYgMTMuOTI2MUM3LjU4MTk2IDE1LjQxNDIgOC4xOTQwNiAxNi43NTk0IDkuMTgwMzUgMTcuNzMwMUw5Ljg0OTQ1IDE4LjM5MjhMMTEuNjgwOCAyMC4yMTZMMTIuOTY5NCAyMS40OTcxVjIxLjQ5OTZMOC4yNjg0IDI2LjE2NTlMNS42ODM3MSAyMy41OTEzQzMuNTQyNjEgMjEuNjM1MSAyLjE5OTQ2IDE4LjgyNjUgMi4xOTk0NiAxNS43MDc0QzIuMTk5NDYgMTQuMzQ0OSAyLjQ1NzE5IDEzLjA0NDEgMi45MjMwOCAxMS44NDY3QzMuMzE5NTggMTAuODcxMSAzLjkwOTM3IDkuODkzIDQuNzAyMzcgOS4xMDQ2MUM3Ljg2NDQ3IDUuOTYwOSAxMi45ODkyIDUuOTYwOSAxNi4xNTEzIDkuMTA0NjFDMTcuMDM4NSA5Ljk4NjYyIDE3LjY4MjggMTEuMDMxMiAxOC4wMzk3IDEyLjEzOTlaIiBmaWxsPSIjMDQ1NUM2Ii8+CjxwYXRoIGQ9Ik0zOS42NTE0IDI4LjM0NjJDNDAuNjY3NSAyOC44MzE1IDQxLjUyNDkgMjkuMzQxNSA0Mi4zMzAzIDMwLjE0MjJDNDUuNDkyNCAzMy4yODYgNDUuNDkyNCAzOC4zODA5IDQyLjMzMDMgNDEuNTI0NkM0MS41ODkzIDQyLjI2MTMgNDAuNzM5MyA0Mi44MjU1IDM5LjgzMjMgNDMuMjE3MkMzOS4zNjE1IDQzLjQyNjYgMzguMjkwOSA0My42NjU2IDM3LjU3NzIgNDMuNjY1NkMzNi4xNjQ3IDQzLjY2NTYgMzQuOTcyNyA0My4yMzY5IDMzLjkyNyA0Mi4yNDlMMTcuNjYzIDI2LjE2MzNMMTIuOTQ5NiAzMC44MjQ3TDI4LjQ1MDMgNDYuMjM1M0MzMC40Mzc3IDQ3Ljk2MjQgMzIuOTE1OSA0OS4wMTkzIDM1LjcwMzggNDkuMDE5M0M0MS42NTEzIDQ5LjAxOTMgNDYuNDczNyA0NC4yMjQ5IDQ2LjQ3MzcgMzguMzExOUM0Ni40NzM3IDMzLjc2MTUgNDMuNjc4NCAyOS44OTgzIDM5LjY1MTQgMjguMzQ2MloiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjIwLjUwNDciIHkxPSIyMy4xODI4IiB4Mj0iNDMuMTk0MyIgeTI9IjQ2LjAwNjQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzA0NTVDNiIvPgo8c3RvcCBvZmZzZXQ9IjAuMyIgc3RvcC1jb2xvcj0iIzMzOEZGRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(389),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(269);



var urlPrefix = '/api/common';
var authUrlPrefix = '/api/auth';
var urls = {
  // Applications
  listApps: '/apps',
  addApp: '/apps',
  fetchApp: '/apps/<app_id>',
  editApp: '/apps/<app_id>',
  fetchAppUsers: '/apps/<app_id>/users',
  addAppUser: '/apps/<app_id>/users',

  // App auth settings
  fetchAppAuthSetting: '/apps/<app_id>/auth_settings',
  editAppAuthSetting: '/apps/<app_id>/auth_settings',

  // App Email Template
  fetchEmailTemplate: '/apps/<app_id>/email_templates',
  updateEmailTemplate: '/apps/<app_id>/email_templates',

  // App SMTP Settings
  fetchAppSMTP: '/apps/<app_id>/email_provider',
  updateAppSMTP: '/apps/<app_id>/email_provider',

  // Hamlet Users
  fetchHamletUsers: '/hamlet_users',
  addHamletUser: '/hamlet_users',
  userIsExist: '/apps/user/exist',
  resignHamletUser: '/hamlet_users/resign',

  // App manage
  authorizeAppManager: '/users/<user_id>/grant_apps',
  changeUserPassword: '/users/<user_id>/password',
  unlockUser: '/users/<user_id>/unlock',
  editUser: '/users/<user_id>',

  // Log events
  fetchEvents: '/events',
  searchLogs: '/logs'

};

var authUrls = {};

var thirdparty = {
  // weixin
  weixin: '/thirdparty/weixin/connect',

  // Account
  unbindUserAccount: '/thirdparty/unbind/user/account'
};

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(urls).map(function (url) {
  urls[url] = urlPrefix + urls[url];
  return url;
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(authUrls).map(function (url) {
  authUrls[url] = authUrlPrefix + authUrls[url];
  return url;
});

/* harmony default export */ __webpack_exports__["a"] = (new function API() {
  this.listApps = function () {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(urls.listApps, {});
  };
  this.addApp = function (param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.addApp, param);
  };
  this.fetchApp = function (id) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(urls.fetchApp.replace('<app_id>', id));
  };
  this.editApp = function (id, param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].put(urls.editApp.replace('<app_id>', id), param);
  };
  this.fetchAppUsers = function (id) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(urls.fetchAppUsers.replace('<app_id>', id));
  };
  this.addAppUser = function (id, param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.addAppUser.replace('<app_id>', id), param);
  };

  this.fetchAppAuthSetting = function (id) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(urls.fetchAppAuthSetting.replace('<app_id>', id));
  };
  this.editAppAuthSetting = function (id, param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.editAppAuthSetting.replace('<app_id>', id), param);
  };

  this.fetchEmailTemplate = function (id) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(urls.fetchEmailTemplate.replace('<app_id>', id));
  };
  this.updateEmailTemplate = function (id, param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.updateEmailTemplate.replace('<app_id>', id), param);
  };

  this.fetchAppSMTP = function (id) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(urls.fetchAppSMTP.replace('<app_id>', id));
  };
  this.updateAppSMTP = function (id, param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.updateAppSMTP.replace('<app_id>', id), param);
  };

  this.fetchHamletUsers = function () {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(urls.fetchHamletUsers, {});
  };
  this.addHamletUser = function (param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.addHamletUser, param);
  };
  this.userIsExist = function (param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.userIsExist, param);
  };
  this.resignHamletUser = function (param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.resignHamletUser, param);
  };

  this.authorizeAppManager = function (id, param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.authorizeAppManager.replace('<user_id>', id), param);
  };
  this.changeUserPassword = function (id, param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.changeUserPassword.replace('<user_id>', id), param);
  };
  this.unlockUser = function (id) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(urls.unlockUser.replace('<user_id>', id));
  };
  this.editUser = function (id, param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].put(urls.editUser.replace('<user_id>', id), param);
  };

  this.fetchEvents = function () {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(urls.fetchEvents);
  };
  this.searchLogs = function (param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(urls.searchLogs, param);
  };

  this.loginByWeixin = function (param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(thirdparty.weixin, param);
  };

  // Account
  this.unbindUserAccount = function (param) {
    return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].post(thirdparty.unbindUserAccount, param);
  };
}());

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locales__ = __webpack_require__(270);








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);

// 从locales里把各个语言的单独分出来
var getLocale = function getLocale(lang, lcs) {
  var locale = {};
  if (Object.prototype.hasOwnProperty.call(lcs, lang)) {
    // 是需要筛选的这一层, 只拿一个key值
    locale = lcs[lang];
  } else {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(lcs).forEach(function (key) {
      locale[key] = getLocale(lang, lcs[key]);
    });
  }
  return locale;
};

// remove pagesize unit
__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en___default.a.el.pagination.pagesize = 'per page';

var enLocale = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, getLocale('en', __WEBPACK_IMPORTED_MODULE_6__locales__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en___default.a);
var zhLocale = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, getLocale('zh', __WEBPACK_IMPORTED_MODULE_6__locales__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_zh_CN___default.a);
var messages = {
  en: enLocale,
  zh: zhLocale
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]({
  locale: 'zh',
  fallbackLocale: 'zh',
  messages: messages,
  missing: function missing(locale, key) {
    var keyPaths = key.split('.');
    if (keyPaths.length > 0) {
      var rlt = keyPaths[keyPaths.length - 1];
      return rlt;
    }
    return null;
  }
}));

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_BindUser__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_BindUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_BindUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_BindWeixin__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_BindWeixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_BindWeixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_sms_SmsLogin__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_sms_SmsLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_sms_SmsLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ForgotPassword__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_ForgotPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_ResetUser__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_ResetUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_ResetUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Account__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Account__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Applications__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Applications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Applications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_AppManage__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_AppManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_AppManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_AppUsers__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_AppUsers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_AppUsers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_HamletUsers__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_HamletUsers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_HamletUsers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Logs__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Logs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_Logs__);

















// import store from '../store';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var root = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('root', {
  template: '<router-view></router-view>'
});

var routes = [{
  path: '/login',
  name: 'login',
  meta: {
    hidden: true
  },
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Login___default.a
}, {
  path: '/',
  component: root,
  redirect: { name: 'applications' },
  meta: {
    auth: ['root', null, '']
  },
  children: [{
    path: 'apps',
    name: 'applications',
    meta: {
      auth: ['root', null, '']
    },
    component: __WEBPACK_IMPORTED_MODULE_9__pages_Applications___default.a
  }, {
    path: 'apps/edit/:appId',
    name: '',
    component: root,
    children: [{
      path: '',
      name: 'app_manage',
      meta: {
        auth: ['root', null, '']
      },
      component: __WEBPACK_IMPORTED_MODULE_10__pages_AppManage___default.a
    }],
    meta: {
      auth: ['root', null, ''],
      hidden: true
    }
  }, {
    path: 'app_users',
    name: 'app_users',
    meta: {
      auth: ['root', null, '']
    },
    component: __WEBPACK_IMPORTED_MODULE_11__pages_AppUsers___default.a
  }, {
    path: 'users',
    name: 'user',
    meta: {
      auth: ['root']
    },
    component: __WEBPACK_IMPORTED_MODULE_12__pages_HamletUsers___default.a
  }, {
    path: 'logs',
    name: 'logs',
    meta: {
      auth: ['root', null, '']
    },
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Logs___default.a
  }, {
    path: 'reset',
    name: 'reset',
    meta: {
      auth: ['root', null, ''],
      hidden: true
    },
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Account___default.a
  }]
}, {
  path: '/bind',
  name: 'Bind',
  meta: {
    hidden: true
  },
  component: __WEBPACK_IMPORTED_MODULE_3__pages_BindUser___default.a
}, {
  path: '/bind/weixin',
  name: 'BindWeixin',
  meta: {
    hidden: true
  },
  component: __WEBPACK_IMPORTED_MODULE_4__pages_BindWeixin___default.a
}, {
  path: '/sms/login',
  name: 'SmsLogin',
  meta: {
    hidden: true
  },
  component: __WEBPACK_IMPORTED_MODULE_5__pages_sms_SmsLogin___default.a
}, {
  path: '/unbind',
  name: 'ApplyForUnbind',
  meta: {
    hidden: true
  },
  component: __WEBPACK_IMPORTED_MODULE_4__pages_BindWeixin___default.a
}, {
  path: '/forgot_password',
  name: 'ForgotPassword',
  meta: {
    hidden: true
  },
  component: __WEBPACK_IMPORTED_MODULE_6__pages_ForgotPassword___default.a
}, {
  path: '/reset_password',
  name: 'Reset',
  meta: {
    hidden: true
  },
  component: __WEBPACK_IMPORTED_MODULE_7__pages_ResetUser___default.a
}, {
  path: '*',
  redirect: { path: '/404' }
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(62);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: debug
}));

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOT_FOUND", function() { return NOT_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PASSWORD_REGEXP", function() { return PASSWORD_REGEXP; });
var NOT_FOUND = 'not found';

// eslint-disable-next-line max-len
var PASSWORD_REGEXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])?.{12,}$/;

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(393),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(61);



// import { Message } from 'element-ui';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

// Vue.http.interceptors.push((request, next) => {
//   request.method = 'GET';
//   request.headers.set('Content-Type', 'application/json');
//   next();
// });
//

function access(url, param, method) {
  /* eslint-disable no-param-reassign */
  param = param || {};
  var ret = null;
  var upperMethod = method.toUpperCase();
  if (upperMethod === 'POST') {
    ret = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(url, param);
  } else if (upperMethod === 'PUT') {
    ret = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put(url, param);
  } else if (upperMethod === 'DELETE') {
    ret = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.delete(url, { params: param });
  } else {
    ret = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(url, { params: param });
  }
  return ret.then(function (res) {
    if (res.body.ok) {
      return res.body;
    }

    /*
    Message.error({
      message: res.body.reason,
    });
    */

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    // throw new Error(res.body.reason);
  }, function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(url, param) {
    return access(url, param, 'get');
  },
  delete: function _delete(url, param) {
    return access(url, param, 'delete');
  },
  post: function post(url, param) {
    return access(url, param, 'post');
  },
  put: function put(url, param) {
    return access(url, param, 'put');
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  common: {
    id: {
      en: 'ID',
      zh: '序号'
    },
    email: {
      en: 'Email',
      zh: '邮箱'
    },
    role: {
      en: 'Role',
      zh: '角色'
    },
    save: {
      en: 'Save',
      zh: '保存'
    },
    pattern: {
      en: 'Pattern',
      zh: '匹配规则'
    },
    edit: {
      en: 'Edit',
      zh: '编辑'
    },
    delete: {
      en: 'Delete',
      zh: '删除'
    },
    cancel: {
      en: 'Cancel',
      zh: '取消'
    },
    confirm: {
      en: 'Confirm',
      zh: '确认'
    },
    name: {
      en: 'Name',
      zh: '名称'
    },
    description: {
      en: 'Description',
      zh: '描述'
    },
    operation: {
      en: 'Operation',
      zh: '操作'
    },
    username: {
      en: 'Username',
      zh: '用户名'
    },
    password: {
      en: 'Password',
      zh: '密码'
    },
    usernamePlaceholder: {
      en: 'Input username',
      zh: '请输入用户名'
    },
    passwordPlaceholder: {
      en: 'Input password',
      zh: '请输入密码'
    },
    confirmPassword: {
      en: 'Confirm Password',
      zh: '确认密码'
    },
    confirmPasswordPlaceholder: {
      en: 'Retype Password',
      zh: '再次输入密码'
    },
    oldPassword: {
      en: 'Old Password',
      zh: '旧密码'
    },
    newPassword: {
      en: 'New Password',
      zh: '新密码'
    },
    sendResetPasswordEmail: {
      en: 'Send Reset Password Email',
      zh: '发送重置密码邮件'
    },
    resetPassword: {
      en: 'Reset Password',
      zh: '重置密码'
    },
    bind: {
      en: 'Bind',
      zh: '绑定'
    },
    login: {
      en: 'Login',
      zh: '登录'
    },
    logout: {
      en: 'Logout',
      zh: '登出'
    },
    last_login: {
      en: 'Last Login At',
      zh: '上次登录时间'
    },
    unlock: {
      en: 'Unlock',
      zh: '解锁'
    },
    lock: {
      en: 'Lock',
      zh: '锁定'
    },
    active: {
      en: 'Active Status',
      zh: '启用'
    },
    forbid: {
      en: 'Forbid',
      zh: '禁用'
    },
    size: {
      en: 'Size',
      zh: '大小'
    },
    created_at: {
      en: 'Created at',
      zh: '创建时间'
    },
    modified_at: {
      en: 'Modified at',
      zh: '修改时间'
    },
    updated_at: {
      en: 'Updated at',
      zh: '更新时间'
    },
    dataUpTo: {
      en: 'Data up to',
      zh: '最新数据'
    },
    uploaded_at: {
      en: 'Upload at',
      zh: '上传时间'
    },
    expired_at: {
      en: 'Expired at',
      zh: '到期时间'
    },
    download: {
      en: 'Download',
      zh: '下载'
    },
    download_count: {
      en: 'Download Count',
      zh: '下载次数'
    },
    status: {
      en: 'Status',
      zh: '状态'
    },
    topic: {
      en: 'Topic',
      zh: '类型'
    },
    message: {
      en: 'Message',
      zh: '详情'
    },
    ip: {
      en: 'IP',
      zh: 'IP'
    },
    eventsSearchPlaceholder: {
      en: 'Please input username',
      zh: '请输入用户名'
    },
    selectPlaceholder: {
      en: 'Please select',
      zh: '请选择'
    },
    forever: {
      en: 'Forever',
      zh: '永久'
    },
    expired: {
      en: 'Expired',
      zh: '已过期'
    },
    to: {
      en: 'to',
      zh: '至'
    },
    warning: {
      en: 'Warning',
      zh: '提示'
    },
    stay: {
      en: 'Stay on this page',
      zh: '留在当前页'
    },
    leave: {
      en: 'Leave now',
      zh: '离开'
    },
    times: {
      en: 'times',
      zh: '次'
    },
    sec: {
      en: 'seconds',
      zh: '秒'
    },
    yes: {
      en: 'Yes',
      zh: '是'
    },
    no: {
      en: 'No',
      zh: '否'
    },
    allow: {
      en: 'allowed',
      zh: '允许'
    },
    admin: {
      en: 'administrator',
      zh: '管理员'
    },
    user: {
      en: 'User',
      zh: '普通用户'
    },
    random_password: {
      en: 'Random Password',
      zh: '随机密码'
    },
    bound_weixin: {
      en: 'Bound Weixin',
      zh: '绑定微信'
    },
    application: {
      en: 'Application',
      zh: '应用'
    },
    weixin: {
      en: 'weChat',
      zh: '微信'
    },
    'weixin/miniprogram': {
      en: 'weChat/Miniprogram',
      zh: '微信/小程序'
    },
    wework: {
      en: 'wework',
      zh: '企业微信'
    },
    addFailed: {
      en: 'add failed',
      zh: '添加失败'
    },
    resignFailed: {
      en: 'Resign failed',
      zh: '离职操作失败'
    },
    contactAdmin: {
      en: 'Please contact the administrator',
      zh: '请联系管理员'
    }
  },
  pages: {
    login: {
      WeixinLogin: {
        en: 'Weixin Login',
        zh: '微信登录'
      },
      ForgotPassword: {
        en: 'Forgot Password?',
        zh: '忘记密码?'
      },
      loginTitle: {
        en: 'Log In',
        zh: '登录'
      },
      loading: {
        en: 'Loading...',
        zh: '登录中...'
      },
      loginError: {
        en: 'Wrong Username / Password',
        zh: '用户名或密码错误'
      },
      accountLock: {
        en: 'Account has been locked because too much login failed, please contact administrator to unlock',
        zh: '登录失败过多，账户已锁定，请联系管理员解锁'
      },
      accountLockWarning: {
        en: 'Account will be locked after {count} login failed',
        zh: '用户名或密码错误，您还可以尝试 {count} 次'
      },
      accountForbid: {
        en: 'If username and password are correct, your account might not be actived, please contact administrator.',
        zh: '如果用户名和密码正确, 您的账户可能未激活, 请联系管理员'
      }
    },
    account: {
      email: {
        en: 'Email',
        zh: '注册邮箱'
      },
      newPassword: {
        en: 'New Password',
        zh: '新密码'
      },
      confirmPassword: {
        en: 'Confirm Password',
        zh: '确认密码'
      },
      resetSuccess: {
        en: 'Password has been reset!',
        zh: '密码重置成功!'
      },
      resetFail: {
        en: 'Password reset failed, please try again!',
        zh: '密码重置失败, 请重试'
      },
      expired: {
        en: 'This password reset link has expired. Please try again.',
        zh: '链接已过期,请重试'
      },
      back_to_login: {
        en: 'Back to Login',
        zh: '返回登录页'
      }
    },
    apps: {
      addApp: {
        en: 'Add applications',
        zh: '创建应用'
      },
      id: {
        en: 'ID',
        zh: '应用ID'
      },
      name: {
        en: 'App Name',
        zh: '应用名称'
      },
      description: {
        en: 'App Description',
        zh: '应用描述'
      },
      app_key: {
        en: 'App Key/ App Secret/ Api Key',
        zh: 'App Key/ App Secret/ Api Key'
      },
      is_active: {
        en: 'Active Status',
        zh: '启用'
      },
      base_url: {
        en: 'Base URL',
        zh: 'Base URL'
      },
      allow_create_user: {
        en: 'Create User',
        zh: '在 Hamlet 添加用户'
      },
      manage: {
        en: 'Manage App',
        zh: '应用管理'
      },
      basic: {
        en: 'Basic',
        zh: '基本设置'
      },
      registration_settings: {
        en: 'Registration Settings',
        zh: '注册设置'
      },
      login_settings: {
        en: 'Login Settings',
        zh: '登录设置'
      },
      email_template: {
        en: 'Email Template',
        zh: '邮件模板'
      },
      email_server: {
        en: 'Email Server',
        zh: '邮件服务器'
      },
      enter_app_name: {
        en: 'Please enter the application name',
        zh: '请输入应用名称'
      }
    },
    appSetting: {
      require_email: {
        en: 'Require Email',
        zh: '需要邮箱'
      },
      need_verify_email: {
        en: 'Require verify Email',
        zh: '需要验证邮箱'
      },
      reset_password_callback: {
        en: 'Reset Password URL',
        zh: '重置密码 URL'
      },
      verify_email_callback: {
        en: 'Verify Email URL',
        zh: '验证邮箱 URL'
      },
      password_pattern: {
        en: 'Password Pattern',
        zh: '密码正则'
      },
      password_description: {
        en: 'Password Description',
        zh: '密码描述'
      },
      allow_weixin_login: {
        en: 'Allow WeChat login',
        zh: '允许微信登录'
      },
      force_weixin_login: {
        en: 'Mandatory WeChat login',
        zh: '强制微信登录'
      },
      ignore_weixin_login: {
        en: 'Exempt from forced WeChat login user group',
        zh: '免除「强制微信登录」用户组'
      },
      login_by_email: {
        en: 'Allow Login by Email',
        zh: '允许邮箱登录'
      },
      login_lock: {
        en: 'Allow Login Lock',
        zh: '开启登录锁定'
      },
      login_max_attempts: {
        en: 'Max Login Attempts',
        zh: '登录出错次数'
      },
      access_token_expiration: {
        en: 'Access Token Expiration',
        zh: 'Access Token 有效期'
      },
      refresh_token_expiration: {
        en: 'Refresh Token Expiration',
        zh: 'Refresh Token 有效期'
      },
      need_login_sms: {
        en: 'Enable SMS authentication',
        zh: '开启短信认证'
      },
      password_limit_reuse: {
        en: 'Limit password reuse',
        zh: '限制密码重用(次数)'
      },
      password_expiration: {
        en: 'Password Validity period(s)',
        zh: '密码有效期(s)'
      },
      revoke_on_logout: {
        en: 'Revoke on logout',
        zh: '退出登录时吊销所有 Token'
      },
      revoke_on_change_pwd: {
        en: 'Revoke on change password',
        zh: '被修改密码时吊销所有 Token'
      },
      host: {
        en: 'HOST',
        zh: 'HOST'
      },
      port: {
        en: 'PORT',
        zh: 'PORT'
      },
      use_ssl: {
        en: 'use-SSL',
        zh: 'use-SSL'
      },
      use_tls: {
        en: 'use-TSL',
        zh: 'use-TSL'
      },
      fromname: {
        en: 'Email from name',
        zh: '邮件显示的发件人'
      },
      verify_email: {
        en: 'Verify Email Template',
        zh: '确认邮箱模板'
      },
      reset_password: {
        en: 'Reset Passwor Email Template',
        zh: '重置密码模板'
      },
      bind_user: {
        en: 'Reset Passwor Email Template',
        zh: '绑定用户模板'
      },
      type: {
        en: 'Email Type',
        zh: '主题'
      },
      content: {
        en: 'Content',
        zh: '内容'
      },
      preview: {
        en: 'Preview',
        zh: '预览'
      },
      name: {
        en: 'Name',
        zh: '名称'
      },
      email_notify: {
        en: '* body must be html',
        zh: '* 必须为 HTML 格式'
      },
      update_success: {
        en: 'Update successful',
        zh: '更新成功'
      },
      allow_register: {
        en: 'Allow register',
        zh: '开放注册'
      }
    },
    logs: {
      extra: {
        en: 'Extra',
        zh: '详细'
      },
      selectApp: {
        en: 'Select App',
        zh: '选择应用'
      },
      selectEvent: {
        en: 'Select Event',
        zh: '选择事件'
      },
      timeRange: {
        en: 'Time Range',
        zh: '时间范围'
      },
      search: {
        en: 'Search',
        zh: '查询'
      },
      startDate: {
        en: 'Start Date',
        zh: '开始日期'
      },
      endDate: {
        en: 'End Date',
        zh: '结束日期'
      },
      order: {
        en: 'No.',
        zh: '序号'
      },
      id: {
        en: 'Log ID',
        zh: '日志ID'
      },
      app_name: {
        en: 'App Name',
        zh: '应用名称'
      },
      username: {
        en: 'Username',
        zh: '用户名称'
      },
      event: {
        en: 'Event',
        zh: '事件'
      },
      ip: {
        en: 'IP',
        zh: 'IP 地址'
      },
      created_at: {
        en: 'Created At',
        zh: '时间'
      }
    },
    hamlet_users: {
      searchPlaceholder: {
        en: 'Please input username or email',
        zh: '请输入用户名或邮箱'
      },
      add_user: {
        en: 'Add User',
        zh: '添加用户'
      },
      add_resign_user: {
        en: 'Add Resign User',
        zh: '新增员工离职'
      },
      resign_user: {
        en: 'Resign User',
        zh: '员工离职'
      },
      order: {
        en: 'No.',
        zh: '序号'
      },
      id: {
        en: 'User ID',
        zh: '用户ID'
      },
      username: {
        en: 'User Name',
        zh: '用户名'
      },
      email: {
        en: 'Email',
        zh: '邮箱'
      },
      role: {
        en: 'Role',
        zh: '角色'
      },
      tel: {
        en: 'Phone Number',
        zh: '电话号码'
      },
      applications: {
        en: 'Managing Applications',
        zh: '可管理应用'
      },
      last_login_at: {
        en: 'Last Login',
        zh: '上次登录时间'
      },
      is_active: {
        en: 'Active Status',
        zh: '启用'
      },
      is_locked: {
        en: 'Is Locked',
        zh: '是否锁定'
      },
      locked: {
        en: 'Locked',
        zh: '已锁定'
      },
      resigned: {
        en: 'Resigned',
        zh: '已离职'
      },
      normal: {
        en: 'Normal',
        zh: '正常'
      },
      inactive: {
        en: 'Inactive',
        zh: '禁用'
      },
      status: {
        en: 'Status',
        zh: '状态'
      },
      no_apps: {
        en: 'You have no app now.',
        zh: '您还没有创建应用, 没有可管理的应用'
      },
      select_app: {
        en: 'Select App',
        zh: '选择应用'
      },
      app_name: {
        en: 'App Name',
        zh: '应用名称'
      },
      thirdparty_users: {
        en: 'Third party account',
        zh: '第三方账号绑定'
      },
      usernameIsEmpty: {
        en: 'The user of the email corresponding to the system is empty',
        zh: '系统中邮箱对应的用户为空'
      },
      usernameNotMatch: {
        en: 'The user corresponding to the email in the system is {name}, which does not match the current user',
        zh: '系统中邮箱对应的用户为 {name}，与当前所填用户不匹配'
      },
      emailIsEmpty: {
        en: "The email of user {username} in the system is empty and can't be set",
        zh: '系统中用户 {username} 对应的邮箱为空，不能再设置'
      },
      emailNotMatch: {
        en: "The user's corresponding email in the system is {name}, which does not match the current email",
        zh: '系统中用户对应的邮箱为 {name}，与当前所填邮箱不匹配'
      },
      forceLoginSms: {
        en: 'SMS authentication is required for login',
        zh: '登录时需要短信认证'
      }
    },
    forgot_password: {
      forgotPasswordTitle: {
        en: 'Forgot Password',
        zh: '忘记密码'
      },
      emailPlaceholder: {
        en: 'Please enter login email',
        zh: '请填写登录邮箱'
      },
      successMessage: {
        en: 'Reset email has sent, please confirm',
        zh: '重置邮件已发送，请登录邮箱确认'
      }
    }
  },
  menu: {
    applications: {
      zh: '应用',
      en: 'Application'
    },
    app_users: {
      zh: '应用用户管理',
      en: 'Application User Management'
    },
    user: {
      zh: 'Hamlet 用户管理',
      en: 'Hamlet User Management'
    },
    logs: {
      zh: '操作日志',
      en: 'Logs'
    }
  },
  personal: {
    logout: {
      en: 'Logout',
      zh: '登出'
    },
    setting: {
      en: 'Setting',
      zh: '设置'
    },
    info: {
      en: 'Personal Info',
      zh: '个人信息'
    }
  },
  verify: {
    forbid_user: {
      en: 'User will not be able to login after forbid, are you sure you want to forbid user {username} ? ',
      zh: '禁用后用户不能登录, 确认要禁用 "{username}" 的账号?'
    },
    active_user: {
      en: 'Avtive user account {username}?',
      zh: '确认要启用 "{username}" 的账号?'
    },
    unlock_user: {
      en: 'unlock user account {username}?',
      zh: '确认要解锁 "{username}" 的账号?'
    }
  },
  bind: {
    page: {
      title: {
        en: 'Bind User',
        zh: '用户绑定'
      },
      description: {
        en: 'You are binding your account to the app...',
        zh: '您正在绑定账号到应用…'
      }
    },
    existed_username: {
      en: 'Username Existed',
      zh: '用户名已存在'
    },
    invalid_app_key: {
      en: 'Invalid App Key',
      zh: '应用 Key 无效'
    },
    invalid_token: {
      en: 'Invalid Token',
      zh: 'Token 无效'
    },
    not_bind_to_app: {
      en: 'Email not exists',
      zh: 'Email 不存在'
    },
    bind_user: {
      en: 'User Already Bind',
      zh: '用户已绑定'
    },
    bind_html: {
      en: 'Email <span> {email} </span> is bind to App <span>{app_name}</span><br>\n           Please click <a href="{app_url}">this link</a> to go to application.',
      zh: '\u60A8\u7684\u90AE\u7BB1 <span> {email} </span> \u5DF2\u7ED1\u5B9A\u5230\u5E94\u7528 <span> {app_name} </span><br>\n           \u70B9\u51FB<a href=" {app_url} ">\u6B64\u94FE\u63A5\u5730\u5740</a>\u76F4\u63A5\u767B\u5F55'
    },
    success: {
      en: 'Success',
      zh: '成功'
    }
  },
  reset: {
    email_sent_success_html: {
      en: 'An email with a reset link has been sent to your email <span> {email} </span> for your account in {app_name} application',
      zh: '您在应用 {app_name} 的账号 <span> {email} </span> 的重置邮件已经发送'
    },
    email_sent_info_html: {
      en: 'If an account exists for <span> {email} </span>, you\'ll get an email with a reset link on resetting your password for your account in {app_name} application',
      zh: '如果 <span> {email} </span> 账号存在，您将收到一封带有重置 {app_name} 应用用户密码链接的邮件'
    },
    reset_success_html: {
      en: 'Your account <span> {email} </span> password in {app_name} application was successfully updated，<br>please click <a href=" {app_url} ">the link</a> to login',
      zh: '您在应用 {app_name} 的账号 <span> {email} </span> 的密码已重置成功，<br>点击<a href=" {app_url} ">此链接地址</a>直接登录'
    },
    resetPasswordTitle: {
      en: 'Reset Password',
      zh: '重置密码'
    },
    needBindUserErrorMessage: {
      en: 'Email not bind to current application',
      zh: '邮箱未绑定到当前应用'
    },
    resetSuccessMessage: {
      en: 'Password has been reset, please login with new password',
      zh: '密码已重置，请用新密码登录'
    },
    newPassword: {
      en: 'New Password',
      zh: '新密码'
    },
    newPasswordPlaceholder: {
      en: 'Please enter new password',
      zh: '请输入新密码'
    },
    confirmNewPassword: {
      en: 'Confirm New Password',
      zh: '确认新密码'
    },
    confirmNewPasswordPlaceholder: {
      en: 'Retype New Password',
      zh: '再次输入新密码'
    }
  },
  rules: {
    app_name: {
      en: 'Please input app name',
      zh: '请填写应用名称'
    },
    base_url: {
      en: 'Please input base url',
      zh: '请填写应用地址'
    },
    host: {
      en: 'Please input host',
      zh: '请输入主机地址'
    },
    port: {
      en: 'Please input port',
      zh: '请输入端口名称'
    },
    username: {
      en: 'Please input username',
      zh: '请输入合法的用户名'
    },
    has_username: {
      en: 'Username already exists',
      zh: '用户已存在'
    },
    password: {
      en: 'Please input password',
      zh: '请输入密码'
    },
    email: {
      en: 'Email format is wrong',
      zh: '邮箱格式错误'
    },
    has_email: {
      en: 'Email already exists',
      zh: '邮箱已存在'
    },
    require_email: {
      en: 'Email is required',
      zh: '请输入邮箱'
    },
    password_format: {
      en: 'Please enter a combination of number and case sensitive letters with at least 12 characters',
      zh: '密码长度至少十二位且须同时包含数字、小写字母和大写字母'
    },
    password_repeat: {
      en: 'The password and its confirm are not the same',
      zh: '两次密码输入不一致'
    },
    old_password: {
      en: 'PLease input old password',
      zh: '请输入旧密码'
    },
    required_item: {
      en: 'This item is required',
      zh: '此项不可为空'
    }
  },
  thirdPartyLogin: {
    successfulLogin: {
      en: 'Successful login',
      zh: '登录成功'
    },
    logout: {
      en: 'Log out',
      zh: '退出登录'
    },
    needRelogin: {
      en: 'Log in again',
      zh: '重新登录'
    },
    bind: {
      en: 'Bind',
      zh: '绑定'
    },
    unbind: {
      en: 'Unbind',
      zh: '解绑'
    },
    applyForUnbinding: {
      en: 'Request for unbinding',
      zh: '申请解绑'
    },
    completeBinding: {
      en: 'Continue',
      zh: '完成绑定'
    },
    bindSuccessfully: {
      en: 'Successful',
      zh: '绑定成功'
    },
    submittedUnbinding: {
      en: 'The request has been successfully submitted',
      zh: '解绑申请提交成功'
    },
    doNotRemindAgain: {
      en: 'Do not remind me again',
      zh: '不再提示'
    },
    needWeChat: {
      en: '{app} requires binding WeChat for a fast login process',
      zh: '{app} 需要绑定微信，便于下次快捷登录'
    },
    recommendWeChat: {
      en: '{app} recommends binding WeChat for a fast login process',
      zh: '{app} 推荐绑定微信，便于下次快捷登录'
    },
    unbindPrompt: {
      en: 'If you need to switch to another WeChat account, please unbind your current account first and re-authorize your new account',
      zh: '如需切换账号，请取消绑定并重新授权'
    },
    isUnbindWeChat: {
      en: 'Are you sure you want to unbind your WeChat account?',
      zh: '是否确认申请解绑微信？'
    },
    willNotLoginWithWeChat: {
      en: "Once the unbinding is approved, you can't use WeChat login",
      zh: '一旦解绑，将不能使用微信登录'
    },
    unbindingDesc: {
      en: 'The submitted request is waiting to be approved by the administrator',
      zh: '已成功提交解绑申请，等待管理员审核通过'
    },
    enterApp: {
      en: 'You will be redirected to the Personal Center in {time}s',
      zh: '{time}s 后自动进入个人主页'
    },
    backHome: {
      en: 'Back to the Personal Center',
      zh: '返回个人主页'
    },
    boundDescription: {
      en: 'Dear {username}, you have successfully bound WeChat account {weixin}',
      zh: '亲爱的 {username}，您已成功绑定微信 {weixin}'
    },
    enterImmediately: {
      en: 'Enter immediately',
      zh: '立即进入'
    },
    accountHasBeenBound: {
      en: 'The account is bound to the current application',
      zh: '账号已绑定到当前应用'
    },
    accountAlreadyUsed: {
      en: 'The current account has been bound to other WeChat accounts',
      zh: '当前账号已绑定其他微信号，请前往登录页使用对应微信进行登录'
    },
    bindingFailed: {
      en: 'Binding failed, please contact the administrator',
      zh: '绑定失败，请联系管理员'
    },
    accountHasBeenBoundToWeChat: {
      en: 'The current account has been bound to WeChat {nickname}',
      zh: '当前账号已绑定过微信 {nickname}，请前往登录页使用对应微信进行登录'
    },
    unbindingFailed: {
      en: 'Unbinding failed',
      zh: '解绑失败'
    },
    enterVerifyCode: {
      en: 'Enter Verification Code',
      zh: '请输入验证码'
    },
    codeHasBeenSentTo: {
      en: 'Verification code has been sent to:',
      zh: '验证码已发送至：'
    },
    getCode: {
      en: 'Get code',
      zh: '获取验证码'
    },
    getCodeAgain: {
      en: 'Get code again',
      zh: '重新获取验证码'
    }
  }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_hamlet__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_index_scss__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_consts__ = __webpack_require__(225);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import axios from 'axios';















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Col"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Row"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Menu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Submenu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["MenuItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["MenuItemGroup"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Card"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Dropdown"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["DropdownMenu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["DropdownItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Switch"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Button"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Input"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Form"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["FormItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Upload"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Radio"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["RadioGroup"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["RadioButton"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Tabs"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["TabPane"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Tag"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Table"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["TableColumn"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Dialog"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Pagination"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Select"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Option"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Checkbox"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["CheckboxGroup"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["CheckboxButton"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Loading"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Collapse"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["CollapseItem"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Progress"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Popover"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Tooltip"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Alert"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["DatePicker"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$consts = __WEBPACK_IMPORTED_MODULE_14__utils_consts__;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_6_moment___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$msgbox = __WEBPACK_IMPORTED_MODULE_5_element_ui__["MessageBox"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$notify = __WEBPACK_IMPORTED_MODULE_5_element_ui__["Notification"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api = __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].store = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$locale = {
  use: function use(lang) {
    __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].locale = lang;
    localStorage.setItem('HAMLET_LANGUAGE', lang);
  },
  current: function current() {
    return __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].locale;
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_hamlet__["a" /* default */], {
  appKey: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
  authRedirect: '/login',
  allowThirdpartyLogin: true
});
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router.beforeEach(function (to, from, next) {
  var locale = to.query.locale;
  if (!locale) {
    locale = 'zh';
  } else {
    /* eslint-disable no-param-reassign */
    delete to.query.locale;
    __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].locale = locale;
    localStorage.setItem('HAMLET_LANGUAGE', locale);
    next({ path: to.path, query: to.query });
  }
  next();
});

var userLocale = navigator.language || navigator.userLanguage;
userLocale = userLocale.split('-')[0];
__WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].locale = localStorage.getItem('HAMLET_LANGUAGE') || userLocale;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_8__App___default.a }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      name: 'app',
      weixinParam: {
        app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
        return_url: 'http://hamlet.yimian.com.cn/apps'
      }
    };
  },

  computed: {
    activeMenu: function activeMenu() {
      return this.$route.name;
    }
  },
  methods: {
    resetPassword: function resetPassword() {
      this.$router.push({ name: 'reset' });
    },
    logout: function logout() {
      var _this = this;

      this.$http.post('/api/auth/logout').then(function (res) {
        if (res.body.ok) {
          _this.$auth.logout().then(function () {
            _this.$router.push({ name: 'login' });
          });
        }
      });
    },
    roleShow: function roleShow(route) {
      return route.meta.auth.indexOf(this.$auth.user().role) !== -1;
    },
    loginByWeixin: function loginByWeixin() {
      var _this2 = this;

      this.weixinParam.return_url = 'http://hamlet.yimian.com.cn' + this.$route.path;
      this.$api.loginByWeixin(this.weixinParam).then(function (res) {
        window.location = res.data.url;
      }).catch(function (res) {
        _this2.$message.error(res.data.data);
      });
    }
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var pwValidator = function pwValidator(rule, value, cb) {
      var ptn = _this.$consts.PASSWORD_REGEXP;
      if (value === '') {
        cb(new Error(_this.$t('common.passwordPlaceholder')));
      } else if (!ptn.test(value)) {
        cb(new Error(_this.$t('rules.password_format')));
      } else {
        cb();
      }
    };
    var pwConfirmValidator = function pwConfirmValidator(rule, value, cb) {
      if (value === '') {
        cb(new Error(_this.$t('common.passwordPlaceholder')));
      } else if (value !== _this.userReset.password) {
        cb(new Error(_this.$t('rules.password_repeat')));
      } else {
        cb();
      }
    };
    return {
      randomPassword: '',
      userReset: {
        appKey: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
        current_password: '',
        password: '',
        confirm_password: ''
      },
      changed: false,
      resetPasswordRules: {
        current_password: [{ required: true, message: this.$t('rules.current_password') }],
        password: [{ required: true, validator: pwValidator }],
        confirm_password: [{ required: true, validator: pwConfirmValidator }]
      }
    };
  },

  methods: {
    createRandomPassword: function createRandomPassword() {
      this.randomPassword = this.$utils.randomPassword();
      this.userReset.password = this.randomPassword;
      this.userReset.confirm_password = this.randomPassword;
    },
    clearPassword: function clearPassword() {
      this.randomPassword = '';
    },
    submitResetPassword: function submitResetPassword() {
      var _this2 = this;

      this.$refs.resetForm.validate(function (validate) {
        if (validate) {
          _this2.$http.post('/api/auth/change_password', _this2.userReset).then(function (res) {
            if (res.data.ok) {
              _this2.changed = true;
            } else {
              _this2.$message.error(_this2.$t('pages.account.resetFail'));
            }
          });
        }
        return validate;
      });
    },
    backToLogin: function backToLogin() {
      var _this3 = this;

      this.$auth.logout().then(function () {
        _this3.$router.push({ name: 'login' });
      });
    }
  },
  created: function created() {
    console.log(this.$auth.user());
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var stringValidator = function stringValidator(rule, value, cb) {
      if (value.trim() === '') {
        cb(new Error(_this.$t('rules.app_name')));
      } else {
        cb();
      }
    };
    return {
      rows: 8,
      active: 'basic',
      appId: this.$route.params.appId,
      editEmail: false,
      basicInfo: {
        name: '',
        description: '',
        base_url: '',
        is_active: false,
        allow_create_user: false
      },
      authSetting: {
        require_email: false,
        verify_email: false,
        allow_register: false,
        reset_password_callback: '',
        verify_email_callback: '',
        password_pattern: '',
        password_description: '',
        allow_weixin_login: true,
        force_weixin_login: false,
        ignore_weixin_login: [],
        login_by_email: false,
        login_lock: false,
        login_max_attempts: 0,
        access_token_expiration: 0,
        refresh_token_expiration: 0,
        need_login_sms: false,
        password_limit_reuse: 0,
        password_expiration: null,
        revoke_on_logout: false,
        revoke_on_change_pwd: false
      },
      smtpSetting: {
        host: '',
        port: '',
        username: '',
        password: '',
        use_ssl: false,
        use_tls: false,
        fromname: ''
      },
      emailTemplates: [],
      emailTemplate: {
        name: '',
        subject: '',
        body: ''
      },
      basicFromRule: {
        name: [{ required: true, validator: stringValidator }]
        /* base_url: [
           { required: true, message: this.$t('rules.base_url') },
         ], */
      },
      smptRules: {
        host: [{ required: true, message: this.$t('rules.host') }],
        port: [{ required: true, message: this.$t('rules.port') }],
        username: [{ required: true, message: this.$t('rules.username') }],
        password: [{ required: true, message: this.$t('common.passwordPlaceholder') }]
      },
      inputVisible: false,
      inputValue: ''
    };
  },

  watch: {
    // eslint-disable-next-line
    'authSetting.force_weixin_login': function authSettingForce_weixin_login(newVal) {
      if (newVal) {
        this.authSetting.allow_weixin_login = true;
      }
    },

    // eslint-disable-next-line
    'authSetting.allow_weixin_login': function authSettingAllow_weixin_login(newVal) {
      if (!newVal) {
        this.authSetting.force_weixin_login = false;
      }
    }
  },
  methods: {
    formatEmail: function formatEmail(html) {
      var ptn = /\bhref=".*"/;
      return html.replace(ptn, 'href="javascript:void(0);"');
    },
    copyExistValue: function copyExistValue(target, source) {
      var newObj = target;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newObj).forEach(function (val) {
        newObj[val] = source[val];
      });
    },
    fetchApp: function fetchApp() {
      var _this2 = this;

      this.$api.fetchApp(this.appId).then(function (res) {
        var app = res.data.application;
        _this2.copyExistValue(_this2.basicInfo, app);
      });
    },
    fetchAuthSetting: function fetchAuthSetting() {
      var _this3 = this;

      this.$api.fetchAppAuthSetting(this.appId).then(function (res) {
        var auth = res.data.auth_settings;
        _this3.copyExistValue(_this3.authSetting, auth);
      });
    },
    fetchAppSMTP: function fetchAppSMTP() {
      var _this4 = this;

      this.$api.fetchAppSMTP(this.appId).then(function (res) {
        var smtp = res.data.email_provider;
        _this4.copyExistValue(_this4.smtpSetting, smtp);
      });
    },
    fetchEmailTemplate: function fetchEmailTemplate() {
      var _this5 = this;

      this.$api.fetchEmailTemplate(this.appId).then(function (res) {
        var templates = res.data.email_templates || [];
        _this5.emailTemplates = templates.filter(function (t) {
          return !!t;
        });
      });
    },
    updateApp: function updateApp() {
      var _this6 = this;

      this.$api.editApp(this.appId, this.basicInfo).then(function () {
        _this6.fetchApp();
        _this6.$message(_this6.$t('pages.appSetting.update_success'));
      });
    },
    updateAuth: function updateAuth() {
      var _this7 = this;

      this.$api.editAppAuthSetting(this.appId, this.authSetting).then(function () {
        _this7.fetchAuthSetting();
        _this7.$message(_this7.$t('pages.appSetting.update_success'));
      });
    },
    updateSmtp: function updateSmtp() {
      var _this8 = this;

      this.$api.updateAppSMTP(this.appId, this.smtpSetting).then(function () {
        _this8.fetchAppSMTP();
        _this8.$message(_this8.$t('pages.appSetting.update_success'));
      });
    },
    updateEmailTemplate: function updateEmailTemplate() {
      var _this9 = this;

      this.$api.updateEmailTemplate(this.appId, this.emailTemplate).then(function () {
        _this9.editEmail = false;
        _this9.fetchEmailTemplate();
        _this9.$message(_this9.$t('pages.appSetting.update_success'));
      });
    },
    editEmailTemplate: function editEmailTemplate(template) {
      this.copyExistValue(this.emailTemplate, template);
      this.editEmail = true;
    },
    handleClose: function handleClose(tag) {
      this.authSetting.ignore_weixin_login.splice(this.authSetting.ignore_weixin_login.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this10 = this;

      this.inputVisible = true;
      this.$nextTick(function () {
        _this10.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;


      if (!this.authSetting.ignore_weixin_login) {
        this.authSetting.ignore_weixin_login = [];
      }

      if (inputValue) {
        this.authSetting.ignore_weixin_login.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  },
  created: function created() {
    this.fetchApp();
    this.fetchAuthSetting();
    this.fetchAppSMTP();
    this.fetchEmailTemplate();
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(36);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppUsers',
  data: function data() {
    var _this = this;

    /* eslint-disable */
    var ptn = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var pwValidator = function pwValidator(rule, value, cb) {
      var ptn = _this.$consts.PASSWORD_REGEXP;
      if (value.trim() === '') {
        cb(new Error(_this.$t('common.passwordPlaceholder')));
      } else if (!ptn.test(value)) {
        cb(new Error(_this.$t('rules.password_format')));
      } else {
        cb();
      }
    };
    var pwConfirmValidator = function pwConfirmValidator(rule, value, cb) {
      var form = void 0;
      if (_this.add) form = 'addUser';
      if (_this.reset) form = 'userReset';
      if (value.trim() === '') {
        cb(new Error(_this.$t('common.passwordPlaceholder')));
      } else if (form.length && value !== _this[form].password) {
        cb(new Error(_this.$t('rules.password_repeat')));
      } else {
        cb();
      }
    };
    var emailValidator = function emailValidator(rule, value, cb) {
      if (!value || value.trim() === '') {
        cb();
      } else if (_this.addUser.username && _this.originalEmail !== '' && _this.addUser.email !== _this.originalEmail) {
        if (!_this.originalEmail) {
          cb(new Error(_this.$t('pages.hamlet_users.emailIsEmpty', { username: _this.addUser.username })));
        }

        cb(new Error(_this.$t('pages.hamlet_users.emailNotMatch', { name: _this.originalEmail })));
      } else if (!_this.emailRegexp.test(value)) {
        cb(new Error(_this.$t('rules.email')));
      } else if (_this.curEmails.indexOf(value.trim()) >= 0) {
        cb(new Error(_this.$t('rules.has_email')));
      } else {
        cb();
      }
    };
    var usernameValidator = function usernameValidator(rule, value, cb) {
      if (!value || value.trim() === '') {
        cb();
      } else if (_this.curUsernames.indexOf(value.trim()) >= 0) {
        cb(new Error(_this.$t('rules.has_username')));
      } else if (_this.addUser.email && _this.originalUsername !== '' && _this.addUser.username !== _this.originalUsername) {
        if (!_this.originalUsername) {
          cb(new Error(_this.$t('pages.hamlet_users.usernameIsEmpty')));
        }

        cb(new Error(_this.$t('pages.hamlet_users.usernameNotMatch', { name: _this.originalUsername })));
      } else {
        cb();
      }
    };

    return {
      pageLoading: false,
      emailRegexp: ptn,
      apps: [],
      allowCreateUserApps: [],
      users: [],
      currentApp: {},
      add: false,
      reset: false,
      randomPassword: '',
      tableCfg: {
        order: null,
        search: '',
        pageSizes: [20, 50, 100],
        pager: {
          pageSize: 20,
          currentPage: 1
        },
        dateFormat: 'YYYY-MM-DD HH:mm:ss'
      },
      editDialog: false,
      editUserForm: {
        id: null,
        username: '',
        email: '',
        role: '',
        force_sms: false,
        tel: ''
      },
      addUser: {
        username: '',
        email: '',
        role: '',
        password: '',
        confirm_password: '',
        force_sms: false,
        tel: ''
      },
      usernameIsValid: false,

      // 用户名在系统中已存在，此时不需要输入密码
      usernameIsExist: false,
      originalUsername: '',
      emailIsValid: false,

      // 邮箱在系统中已存在
      emailIsExist: false,
      originalEmail: '',
      userReset: {
        username: '',
        id: '',
        password: '',
        confirm_password: ''
      },
      requireEmail: false,
      addUserRules: {
        username: [{ required: false, validator: usernameValidator }],
        email: [{ required: false, validator: emailValidator }],
        password: [{ required: true, validator: pwValidator }],
        confirm_password: [{ required: true, validator: pwConfirmValidator }]
      },
      resetPasswordRules: {
        password: [{ required: true, validator: pwValidator }],
        confirm_password: [{ required: true, validator: pwConfirmValidator }]
      },
      thirdpartyInfo: {}
    };
  },

  computed: {
    curEmails: function curEmails() {
      return this.users.map(function (u) {
        return u.email;
      });
    },
    curUsernames: function curUsernames() {
      return this.users.map(function (u) {
        return u.username;
      });
    },
    filteredUsers: function filteredUsers() {
      var _this2 = this;

      var users = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.users));

      if (this.tableCfg.search) {
        users = users.filter(function (user) {
          return user.username.toLowerCase().indexOf(_this2.tableCfg.search.toLowerCase()) !== -1 || user.email.toLowerCase().indexOf(_this2.tableCfg.search.toLowerCase()) !== -1;
        });
      }

      if (this.tableCfg.order) {
        var _order = this.tableCfg.order.order === 'ascending';

        users.sort(function (a, b) {
          var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* getValueByPath */])(a, _this2.tableCfg.order.prop);
          var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* getValueByPath */])(b, _this2.tableCfg.order.prop);
          return _order ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* compare */])(_a, _b) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* compare */])(_b, _a);
        });
      }

      return users;
    },
    currentUsers: function currentUsers() {
      var start = (this.tableCfg.pager.currentPage - 1) * this.tableCfg.pager.pageSize;
      var end = this.tableCfg.pager.currentPage * this.tableCfg.pager.pageSize;
      return this.filteredUsers.slice(start, end);
    },
    usersTotal: function usersTotal() {
      return this.filteredUsers.length;
    }
  },
  watch: {
    currentApp: function currentApp(val) {
      if (val && val.id) {
        this.fetchAppUsers(val.id);
        this.fetchAuthSetting(val.id);
      }
      // 重置tableCfg
      this.tableCfg.search = '';
      this.tableCfg.pager.currentPage = 1;
      this.tableCfg.pager.pageSize = 20;
      /* if (val.allow_create_user) {
        this.fetchAuthSetting(val.id);
       } else {
        this.requireEmail = false;
       }*/
    },


    /* eslint-disable object-shorthand */
    'addUser.username': function addUserUsername(newVal, oldVal) {
      if (newVal && oldVal) {
        this.originalEmail = '';
        this.$refs.addForm.validateField('email');
      }
    },
    'addUser.email': function addUserEmail(newVal, oldVal) {
      if (newVal && oldVal) {
        this.originalUsername = '';
        this.$refs.addForm.validateField('username');
      }
    }
  },
  methods: {
    createRandomPassword: function createRandomPassword() {
      this.randomPassword = this.$utils.randomPassword();
      this.addUser.password = this.randomPassword;
      this.addUser.confirm_password = this.randomPassword;
      this.userReset.password = this.randomPassword;
      this.userReset.confirm_password = this.randomPassword;
    },
    toCreateUser: function toCreateUser() {
      this.addUser.force_sms = false;
      this.addUser.tel = '';
      this.add = true;
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      this.tableCfg.order = column ? { prop: prop, order: order } : null;
    },
    handleUsersCurPageChange: function handleUsersCurPageChange(currentPage) {
      this.tableCfg.pager.currentPage = currentPage;
    },
    handleUsersSizeChange: function handleUsersSizeChange(pageSize) {
      this.tableCfg.pager.pageSize = pageSize;
    },
    popUpEditUserDialog: function popUpEditUserDialog(row) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.editUserForm, {
        id: row.id,
        username: row.username,
        email: row.email,
        role: row.role,
        force_sms: row.force_sms,
        tel: row.tel
      });
      this.editDialog = true;
    },
    resetAdd: function resetAdd() {
      this.clearPassword();
      this.$refs.addForm.resetFields();
      this.usernameIsValid = false;
      this.usernameIsExist = false;
      this.emailIsValid = false;
      this.emailIsExist = false;
      this.originalUsername = '';
      this.originalEmail = '';
    },
    clearResetform: function clearResetform() {
      this.clearPassword();
      this.$refs.resetForm.resetFields();
    },
    clearPassword: function clearPassword() {
      this.randomPassword = '';
    },
    formatDatetime: function formatDatetime(r, c) {
      var ds = r[c.property];
      return ds ? this.$moment(ds).utcOffset(+960).format('YYYY/M/DD HH:mm:ss') : '';
    },
    fetchApps: function fetchApps() {
      var _this3 = this;

      this.$api.listApps().then(function (res) {
        // this.apps = res.data.applications;
        _this3.apps = res.data.applications.filter(function (app) {
          return app.name !== 'Hamlet';
        });
        _this3.currentApp = _this3.apps[0];
      });
    },
    fetchAppUsers: function fetchAppUsers(id) {
      var _this4 = this;

      this.pageLoading = true;
      this.$api.fetchAppUsers(id).then(function (res) {
        var cleaningRecords = [];
        for (var i = 0, len = res.data.users.length; i < len; i += 1) {
          var record = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.data.users[i]); // copy object. avoid vuex outside change error
          if (!record.is_active) {
            record.status = _this4.$t('pages.hamlet_users.inactive');
          } else if (record.is_locked) {
            record.status = _this4.$t('pages.hamlet_users.locked');
          } else {
            record.status = _this4.$t('pages.hamlet_users.normal');
          }
          record.username = record.username || ''; // 方便搜索、排序  部分用户名字为空
          record.email = record.email || ''; // 方便搜索、排序
          cleaningRecords.push(record);
        }
        _this4.users = cleaningRecords;
      }).finally(function () {
        _this4.pageLoading = false;
      });
    },
    fetchAuthSetting: function fetchAuthSetting(id) {
      this.$api.fetchAppAuthSetting(id).then(function (res) {
        // this.requireEmail = res.data.auth_settings.require_email;
        // this.addUserRules.email[0].required = this.requireEmail;
      });
    },
    addAppUser: function addAppUser() {
      var _this5 = this;

      this.$api.addAppUser(this.currentApp.id, this.addUser).then(function () {
        _this5.add = false;
        _this5.fetchAppUsers(_this5.currentApp.id);
      }).catch(function (res) {
        console.log('res', res);
        _this5.$message, error(_this5.$t('common.addFailed'));
      });
    },
    editUser: function editUser(id, param) {
      var _this6 = this;

      return this.$api.editUser(id, param).then(function (res) {
        _this6.fetchAppUsers(_this6.currentApp.id);
      });
    },
    unlock: function unlock(id) {
      var _this7 = this;

      this.$api.unlockUser(id).then(function (res) {
        _this7.fetchAppUsers(_this7.currentApp.id);
      });
    },
    changeUserPassword: function changeUserPassword() {
      var _this8 = this;

      this.$api.changeUserPassword(this.userReset.id, {
        password: this.userReset.password,
        confirm_password: this.userReset.confirm_password
      }).then(function (res) {
        _this8.reset = false;
      });
    },
    resetPassword: function resetPassword(row) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.userReset, {
        username: row.username,
        id: row.id
      });
      this.reset = true;
    },
    submitAddUser: function submitAddUser() {
      var _this9 = this;

      this.$nextTick(function () {
        _this9.$refs.addForm.validate(function (validate) {
          if (validate) {
            _this9.$api.userIsExist({
              username: _this9.addUser.username,
              email: _this9.addUser.email
            }).then(function () {
              _this9.usernameIsExist = false;
              _this9.emailIsExist = false;
              _this9.$nextTick(function () {
                _this9.$refs.addForm.validate(function (validate) {
                  if (validate) {
                    _this9.addAppUser();
                  }
                });
              });
            }).catch(function (res) {
              var data = res.body.data;
              _this9.$nextTick(function () {
                if ((!_this9.addUser.username || data.user.username === _this9.addUser.username) && (!_this9.addUser.email || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* compareIgnoreCase */])(data.user.email, _this9.addUser.email))) {
                  _this9.addAppUser();
                }
              });
            });
          }
        });
      });
    },
    submitEditUser: function submitEditUser() {
      var _this10 = this;

      // no need validate, email and role can be null
      this.editUser(this.editUserForm.id, {
        role: this.editUserForm.role,
        force_sms: this.editUserForm.force_sms,
        tel: this.editUserForm.tel
      }).then(function () {
        _this10.editDialog = false;
      });
    },
    submitResetPassword: function submitResetPassword() {
      var _this11 = this;

      this.$refs.resetForm.validate(function (validate) {
        if (validate) {
          _this11.changeUserPassword();
        }
      });
    },
    unlockUser: function unlockUser(row) {
      var _this12 = this;

      this.$msgbox.confirm(this.$t('verify.unlock_user', { 'username': row.username }), this.$t('common.unlock'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel')
      }).then(function () {
        _this12.unlock(row.id);
      });
    },
    activeUser: function activeUser(row) {
      var _this13 = this;

      var message = row.is_active ? 'verify.forbid_user' : 'verify.active_user';
      var title = row.is_active ? 'common.forbid' : 'common.active';
      this.$msgbox.confirm(this.$t(message, { 'username': row.username }), this.$t(title), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel')
      }).then(function () {
        _this13.editUser(row.id, { is_active: !row.is_active });
      });
    },
    showThirdpartyInfo: function showThirdpartyInfo(val) {},
    checkUsername: function checkUsername() {
      var _this14 = this;

      this.usernameIsValid = !!(this.addUser.username && !this.users.find(function (user) {
        return user.username === _this14.addUser.username;
      }));
      if (!this.usernameIsValid) {
        // this.originalUsername = '';
        this.originalEmail = '';
        this.usernameIsExist = false;
      }

      this.$refs.addForm.validateField('username');
      this.$refs.addForm.validateField('email');
      if (this.usernameIsValid) {
        this.$api.userIsExist({
          username: this.addUser.username
        }).then(function (val) {
          _this14.usernameIsExist = false;
          _this14.originalEmail = '';
        }).catch(function (res) {
          console.log('res', res.body.data);
          var data = res.body.data;

          // this.originalUsername = data.user.username;
          _this14.originalEmail = data.user.email;

          // 仅邮箱为空时，自动填充
          if (!_this14.addUser.email || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* compareIgnoreCase */])(data.user.email, _this14.addUser.email)) {
            _this14.addUser.email = data.user.email;
            _this14.emailIsValid = true;
            _this14.emailIsExist = true;
          }

          _this14.usernameIsExist = true;
        }).finally(function () {
          // this.$refs.addForm.validateField('email');
          _this14.$refs.addForm.validate();
        });
      }
    },
    checkEmail: function checkEmail() {
      var _this15 = this;

      this.emailIsValid = !!(this.addUser.email && this.emailRegexp.test(this.addUser.email) && !this.users.find(function (user) {
        return user.email === _this15.addUser.email;
      }));
      if (!this.emailIsValid) {
        // this.originalEmail = '';
        this.originalUsername = '';
        this.emailIsExist = false;
      }

      this.$refs.addForm.validateField('username');
      this.$refs.addForm.validateField('email');
      if (this.emailIsValid) {
        this.$api.userIsExist({
          email: this.addUser.email
        }).then(function () {
          _this15.emailIsExist = false;
          _this15.originalUsername = '';
        }).catch(function (res) {
          var data = res.body.data;

          _this15.originalUsername = data.user.username;
          // this.originalEmail = data.user.email;

          // 仅邮箱为空时，自动填充
          if (!_this15.addUser.username || data.user.username === _this15.addUser.username) {
            _this15.addUser.username = data.user.username;
            _this15.usernameIsValid = true;
            _this15.usernameIsExist = true;
          }

          _this15.emailIsExist = true;
        }).finally(function () {
          _this15.$refs.addForm.validate();
        });
      }
    },
    toUnbindUserAccount: function toUnbindUserAccount(user, type) {
      var _this16 = this;

      this.$api.unbindUserAccount({
        app_id: this.currentApp.id,
        user_id: user.user_id,
        type: type
      }).then(function () {
        _this16.$message.success('已解绑');
        _this16.fetchAppUsers(_this16.currentApp.id);
      }).catch(function (err) {
        console.log('>>>解绑失败>>>', err);
        _this16.$message.error('解绑失败');
      });
    }
  },
  created: function created() {
    this.fetchApps();
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Applications',
  data: function data() {
    var _this = this;

    var stringValidator = function stringValidator(rule, value, cb) {
      if (value.trim() === '') {
        cb(new Error(_this.$t('rules.app_name')));
      } else {
        cb();
      }
    };
    return {
      search: '',
      apps: [],
      add: false,
      appForm: {
        name: '',
        description: ''
      },
      addFromRule: {
        name: [{ required: true, validator: stringValidator }]
        /* base_url: [
           { required: true, message: this.$t('rules.base_url') },
         ], */
      }
    };
  },

  computed: {
    filteredApps: function filteredApps() {
      var _this2 = this;

      if (!this.search) {
        return this.apps;
      }

      return this.apps.filter(function (app) {
        return app.name.toLowerCase().indexOf(_this2.search.toLowerCase()) !== -1;
      });
    }
  },
  methods: {
    resetAdd: function resetAdd() {
      this.$refs.addForm.resetFields();
    },
    formatDatetime: function formatDatetime(r, c) {
      var ds = r[c.property];
      return ds ? this.$moment(ds).utcOffset(+960).format('YYYY/M/DD HH:mm:ss') : '';
    },
    fetchApps: function fetchApps() {
      var _this3 = this;

      this.$api.listApps().then(function (res) {
        _this3.apps = res.data.applications;
      });
    },
    addApp: function addApp() {
      var _this4 = this;

      this.$refs.addForm.validate(function (validate) {
        if (validate) {
          _this4.$api.addApp(_this4.appForm).then(function () {
            _this4.add = false;
            _this4.resetAdd();
            _this4.fetchApps();
          });
        }
        return validate;
      });
    },
    manageApp: function manageApp(row) {
      this.$router.push({
        name: 'app_manage',
        params: {
          appId: row.id
        }
      });
    }
  },
  created: function created() {
    this.fetchApps();
  }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var usernameValidator = function usernameValidator(rule, value, cb) {
      if (!value || !String(value).trim()) {
        cb(new Error(_this.$t('rules.username')));
      } else {
        cb();
      }
    };
    var pwValidator = function pwValidator(rule, value, cb) {
      var ptn = _this.$consts.PASSWORD_REGEXP;
      if (value === '') {
        cb(new Error(_this.$t('common.passwordPlaceholder')));
      } else if (!ptn.test(value)) {
        cb(new Error(_this.$t('rules.password_format')));
      } else {
        cb();
      }
    };
    var pwConfirmValidator = function pwConfirmValidator(rule, value, cb) {
      if (!value) {
        cb(new Error(_this.$t('common.confirmPasswordPlaceholder')));
      } else if (value !== _this.confirmForm.password) {
        cb(new Error(_this.$t('rules.password_repeat')));
      } else {
        cb();
      }
    };
    return {
      app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
      logo_url: null,
      bindParams: {
        email: '',
        app_name: '',
        app_url: ''
      },
      confirmForm: {
        email: null,
        username: null,
        password: null,
        confirmPassword: null
      },
      rules: {
        username: [{ required: true, validator: usernameValidator, trigger: 'change' }],
        password: [{ required: true, validator: pwValidator, trigger: 'change' }],
        confirmPassword: [{ required: true, validator: pwConfirmValidator, trigger: 'change' }]
      },
      current_bind: '',
      readOnlyFlag: true,
      password_error: false,
      forbid: false
    };
  },

  methods: {
    validateUrlQuery: function validateUrlQuery() {
      var query = this.$route.query;
      if (!query.app_key) {
        this.$message.error(this.$t('bind.invalid_app_key'));
      } else if (!query.token) {
        this.$message.error(this.$t('bind.invalid_token'));
      }
    },
    initQuery: function initQuery() {
      var _this2 = this;

      var args = this.$route.query;
      if (args) {
        var callbackParams = { client_app_key: args.app_key, token: args.token };
        this.$http.post('/api/auth/bind/callback', callbackParams).then(function (res) {
          if (res.body.ok) {
            _this2.updateConfirmParams(res.body.data);
            _this2.logo_url = res.body.data.logo_url;
          } else if (res.body.reason === 'invalid argument' && 'token' in res.body.data) {
            _this2.$message.error(_this2.$t('bind.invalid_token'));
          } else if (res.body.reason === 'invalid argument' && 'client_app_key' in res.body.data) {
            _this2.$message.error(_this2.$t('bind.invalid_app_key'));
          }
        });
      }
    },
    updateConfirmParams: function updateConfirmParams(data) {
      this.bindParams = data;
      this.current_bind = data.mode;
      this.confirmForm.email = data.email;
      this.confirmForm.app_name = data.app_name;
      this.confirmForm.app_user_id = data.app_user_id;
      if (this.current_bind === 'bind_user') {
        this.$message.error(this.$t('bind.bind_user'));
      }
    },
    confirmBind: function confirmBind() {
      var _this3 = this;

      this.$refs.confirmForm.validate(function (valid) {
        if (valid) {
          _this3.$http.post('/api/auth/bind/confirm', _this3.confirmForm).then(function (res) {
            if (res.body.ok) {
              _this3.$message.success(_this3.$t('bind.success'));
              _this3.current_bind = 'bind_user';
            } else if (res.body.reason === 'invalid username') {
              _this3.$message.error(_this3.$t('bind.existed_username'));
            } else if (res.body.reason === 'invalid argument' && 'password' in res.body.data) {
              _this3.$message.error(_this3.$t('rules.password'));
            } else if (res.body.reason === 'not found') {
              _this3.$message.error(_this3.$t('bind.invalid_token'));
            }
          }).catch(function (res) {
            if (res.body.reason === 'not found') {
              _this3.$message.error(_this3.$t('bind.invalid_token'));
            }
          });
        }
      });
    }
  },
  created: function created() {
    this.validateUrlQuery();
    this.initQuery();
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppLogo__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppLogo__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BindWeixin',
  components: {
    AppLogo: __WEBPACK_IMPORTED_MODULE_3__components_AppLogo___default.a
  },
  data: function data() {
    return {
      pageLoading: true,
      unbindLoading: false,
      binding: false,
      successfullyBound: false,

      // 当前页面是否为「申请解绑页」
      applyUnbinding: false,
      bindInfo: {},
      logo: '',
      appLogo: 'yimian',
      tokens: {},
      urls: {
        home_url: "https://hamlet.yimian.com.cn" || 'https://hamlet.yimian.com.cn',
        bindInfo: '/thirdparty/bind/info',
        miniProgramBind: '/thirdparty/weixin/miniprogram/bind',
        weixinConnect: '/thirdparty/weixin/connect',
        unbindAccount: '/thirdparty/unbind/account'
      },
      time: 6,
      timer: null,
      isMiniprogram: false,
      isForceWeixinLogin: false
    };
  },

  computed: {
    headers: function headers() {
      var query = this.$route.query;

      var token = query.tk || query.hamlet_tk;
      if (token) {
        return {
          Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token
        };
      }

      return {};
    }
  },
  created: function created() {
    var query = this.$route.query;

    if (!(query.ru && query.ak) && !(query.hamlet_a_ru && query.hamlet_tk) && !(query.ak && query.tk)) {
      this.pageLoading = false;
      this.toReturnUrl();
    }

    // 这里直接使用是否有「页面返回路径 page_path」作为依据判断是否为小程序
    this.isMiniprogram = !!query.pap;
    this.isForceWeixinLogin = !!query.auk;
    if (query.hamlet_tk) {
      this.successfullyBound = true;
      this.countDown();
    } else if (this.$route.name === 'ApplyForUnbind') {
      this.logo = 'warning';
      this.applyUnbinding = true;
      this.pageLoading = false;
    }

    if (!this.applyUnbinding) {
      this.getBindInfo();
    }

    if (this.isMiniprogram) {
      this.isForceWeixinLogin = true;
      this.addWxJsSdk();
    }

    if (query.lang && this.$locale) {
      this.$locale.use(query.lang === 'en' ? 'en' : 'zh');
    }
  },
  beforeRouteLeave: function beforeRouteLeave() {
    clearInterval(this.timer);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    getBindInfo: function getBindInfo() {
      var _this = this;

      this.pageLoading = true;
      var query = this.$route.query;


      this.httpAxios(this.urls.bindInfo, {
        app_key: query.ak || query.hamlet_ak,
        auth_key: query.auk,
        auth_token: query.aut
      }, 'GET', this.headers).then(function (val) {
        _this.bindInfo = val.data || {};
      }).catch(function (err) {
        console.log('>>>>err\n', err);
        if (err.status === 401) {
          _this.toReturnUrl();
        }
      }).finally(function () {
        setTimeout(function () {
          _this.pageLoading = false;
        }, 600);
      });
    },
    addWxJsSdk: function addWxJsSdk() {
      var el = document.createElement('script');
      el.setAttribute('src', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js');
      document.head.appendChild(el);
    },
    httpAxios: function httpAxios(url, data) {
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
      var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var params = { method: method, url: url };

      if (method === 'GET') {
        params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(params, { params: data });
      } else {
        params.data = data;
      }

      if (headers) {
        params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(params, { headers: headers });
      }

      // console.log('>>>>>>params', params);
      return __WEBPACK_IMPORTED_MODULE_2_axios___default()(params).then(function (res) {
        if (res.data.ok) {
          return res.data;
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res.data);
      }).catch(function (err) {
        console.error('>>>http>>>err>>>\n', err);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err.response || err);
      });
    },
    toBindWx: function toBindWx() {
      var _this2 = this;

      this.binding = true;
      var query = this.$route.query;

      // 有 auth_token 和 auth_key 则直接绑定, 小程序

      if (query.aut && query.auk) {
        this.httpAxios(this.urls.miniProgramBind, {
          app_key: query.ak,
          auth_key: query.auk,
          auth_token: query.aut
        }, 'POST').then(function (val) {
          var data = val.data;

          if (data.access_token) {
            _this2.successfullyBound = true;
            _this2.tokens = data;
            _this2.countDown();
          }
        }).catch(function (err) {
          console.log('>>>>bind>>>err', err);
          var reason = err.reason;

          if (reason === 'Already bind to current app') {
            _this2.$message.error(_this2.$t('thirdPartyLogin.accountHasBeenBound'));
          } else if (reason === 'This account has been bound') {
            _this2.$message.error(_this2.$t('thirdPartyLogin.accountAlreadyUsed'));
          } else {
            _this2.$message.error(reason);
          }
        }).finally(function () {
          _this2.binding = false;
        });
      } else {
        this.httpAxios(this.urls.weixinConnect, {
          app_key: query.ak,
          auth_key: query.auk,
          return_url: '' + window.location.origin + window.location.pathname,
          app_return_url: query.ru
        }, 'POST', this.headers).then(function (val) {
          console.log('>>>connect>>> successfully', val);
          window.location = val.data.url;
        }).catch(function (res) {
          console.log('>>>connect>>> failed', res);
          var data = res.data;

          if (res.reason === 'This account has been bound') {
            _this2.$message.error(_this2.$t('thirdPartyLogin.accountHasBeenBoundToWeChat', { nickname: data.nickname }));
          } else {
            _this2.$message.error(_this2.$t('thirdPartyLogin.bindingFailed'));
          }
        }).finally(function () {
          _this2.binding = false;
        });
      }
    },
    countDown: function countDown() {
      var _this3 = this;

      this.timer = setInterval(function () {
        _this3.time -= 1;
        if (_this3.time <= 0) {
          clearInterval(_this3.timer);
          _this3.enterApp();
        }
      }, 1000);
    },
    enterApp: function enterApp() {
      clearInterval(this.timer);
      var query = this.$route.query;

      if (this.isMiniprogram) {
        var wx = window.wx.miniProgram;
        var pagePath = query.pap;
        // wx.postMessage({ data: this.tokens });
        // wx.redirectTo({ url:pagePath });

        var url = query.ru + '?tk=' + this.tokens.access_token + '&rtk=' + this.tokens.refresh_token;
        url = pagePath + '?url=' + encodeURIComponent(url);
        console.log('\n\n>>>url>>>\n\n', url);
        wx.navigateTo({ url: url });
      } else if (this.applyUnbinding) {
        // 进入到「申请解绑页」前，原有 APP 已登录
        this.toReturnUrl();
      } else {
        // 如果不是解绑页，返回原有 APP 时需要带上 token
        window.location = query.hamlet_a_ru + '?thirdparty_connect_access_token=' + query.hamlet_tk + '&thirdparty_connect_refresh_token=' + query.hamlet_rtk;
      }
    },
    toLoginPage: function toLoginPage() {
      var wx = window.wx.miniProgram;
      clearInterval(this.timer);
      wx.redirectTo({ url: '/pages/index/index' });
    },
    toReturnUrl: function toReturnUrl() {
      var query = this.$route.query;

      window.location = query.ru || query.a_ru || query.hamlet_a_ru || this.urls.home_url;
    },
    getNickname: function getNickname() {
      if (this.bindInfo.nickname) {
        return this.bindInfo.nickname;
      }

      var tpUser = this.bindInfo.thirdparty_users;
      return tpUser && tpUser.weixin ? tpUser.weixin.nickname : '';
    },
    unbindAccount: function unbindAccount() {
      var _this4 = this;

      this.unbindLoading = true;
      var query = this.$route.query;

      this.httpAxios(this.urls.unbindAccount, {
        app_key: query.ak,
        type: 'weixin'
      }, 'POST', this.headers).then(function () {
        _this4.logo = 'success';
        _this4.countDown();
      }).catch(function (res) {
        console.log('unbind failed>>>', res);
        _this4.$message.error(_this4.$t('thirdPartyLogin.unbindingFailed'));
      }).finally(function () {
        _this4.unbindLoading = false;
      });
    }
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    /* eslint-disable */
    var ptn = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var emailValidator = function emailValidator(rule, value, cb) {
      if (!value || value.trim() === '') {
        cb(new Error(_this.$t('rules.require_email')));
      } else if (!ptn.test(value)) {
        cb(new Error(_this.$t('rules.email')));
      } else {
        cb();
      }
    };
    return {
      app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
      logo_url: null,
      resetParams: {
        email: '',
        app_name: ''
      },
      confirmForm: {
        email: null,
        app_name: null
      },
      rules: {
        email: [{ required: false, validator: emailValidator }]
      },
      current_reset: '',
      password_error: false,
      forbid: false
    };
  },

  methods: {
    validateUrlQuery: function validateUrlQuery() {
      var query = this.$route.query;
      if (!query.app_key) {
        this.$message.error(this.$t('bind.invalid_app_key'));
      }
    },
    initQuery: function initQuery() {
      var _this2 = this;

      var args = this.$route.query;
      this.current_reset = 'reset_password';
      if (args) {
        var url = '/api/auth/app/' + args.app_key;
        this.$http.get(url).then(function (res) {
          console.log('res', res);
          if (res.body.ok) {
            _this2.updateConfirmParams(res.body.data);
            _this2.logo_url = res.body.data.logo_url;
          } else if (res.body.reason === 'invalid argument' && 'client_app_key' in res.body.data) {
            _this2.$message.error(_this2.$t('bind.invalid_app_key'));
          }
        });
      }
    },
    updateConfirmParams: function updateConfirmParams(data) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.confirmForm.app_name = data.name;
      });
    },
    confirmRecover: function confirmRecover() {
      var _this4 = this;

      this.$refs.confirmForm.validate(function (valid) {
        if (valid) {
          var params = {
            client_app_key: _this4.$route.query.app_key,
            email: _this4.confirmForm.email,
            callback_url: _this4.$route.query
          };
          if (_this4.$route.query.callback_url) {
            params['callback_url'] = _this4.$route.query.callback_url;
          }

          _this4.$http.post('/api/auth/recover_password', params).then(function (res) {
            _this4.current_reset = 'reset_password_checked';
            // const { err_code: errCode, reason } = res.body;
            // if (errCode && reason) {
            //   this.$message.error(reason);
            // } else {
            //   this.$message.error('Unknown. Please contact an administrator');
            // }
          }).catch(function (res) {
            _this4.$message.error('Unknown. Please contact an administrator!');
          });
        }
      });
    }
  },
  created: function created() {
    console.log("production");
    this.validateUrlQuery();
    this.initQuery();
  }
});

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__(36);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HamletUsers',
  data: function data() {
    var _this = this;

    /* eslint-disable */
    var ptn = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var stringValidator = function stringValidator(rule, value, cb) {
      if (!value || value.trim() === '') {
        cb();
      } else if (_this.users.find(function (user) {
        return user.username === value;
      })) {
        cb(new Error(_this.$t('rules.has_username')));
      } else if (_this.addUser.email && _this.originalUsername !== '' && _this.addUser.username !== _this.originalUsername) {
        if (!_this.originalUsername) {
          cb(new Error(_this.$t('pages.hamlet_users.usernameIsEmpty')));
        }

        cb(new Error(_this.$t('pages.hamlet_users.usernameNotMatch', { name: _this.originalUsername })));
      } else {
        cb();
      }
    };
    var emailValidator = function emailValidator(rule, value, cb) {
      if (!value || value.trim() === '') {
        cb();
      } else if (_this.addUser.username && _this.originalEmail !== '' && _this.addUser.email !== _this.originalEmail) {
        if (!_this.originalEmail) {
          cb(new Error(_this.$t('pages.hamlet_users.emailIsEmpty', { username: _this.addUser.username })));
        }

        cb(new Error(_this.$t('pages.hamlet_users.emailNotMatch', { name: _this.originalEmail })));
      } else if (!_this.emailRegexp.test(value)) {
        cb(new Error(_this.$t('rules.email')));
      } else if (_this.users.find(function (user) {
        return user.email === value;
      })) {
        cb(new Error(_this.$t('rules.has_email')));
      } else {
        cb();
      }
    };
    var pwValidator = function pwValidator(rule, value, cb) {
      var ptn = _this.$consts.PASSWORD_REGEXP;
      if (value.trim() === '') {
        cb(new Error(_this.$t('common.passwordPlaceholder')));
      } else if (!ptn.test(value)) {
        cb(new Error(_this.$t('rules.password_format')));
      } else {
        cb();
      }
    };
    var pwConfirmValidator = function pwConfirmValidator(rule, value, cb) {
      var form = void 0;
      if (_this.add) form = 'addUser';
      if (_this.reset) form = 'userReset';
      if (value.trim() === '') {
        cb(new Error(_this.$t('common.passwordPlaceholder')));
      } else if (form.length && value !== _this[form].password) {
        cb(new Error(_this.$t('rules.password_repeat')));
      } else {
        cb();
      }
    };

    return {
      pageLoading: false,
      emailRegexp: ptn,
      randomPassword: '',
      users: [],
      apps: [],
      edit: false,
      add: false,
      reset: false,
      resign: false,
      userApps: {
        id: '',
        username: '',
        app_ids: []
      },
      addUser: {
        username: '',
        email: '',
        password: '',
        confirm_password: ''
      },
      resignForm: {
        email: null
      },
      usernameIsValid: false,

      // 用户名在系统中已存在，此时不需要输入密码
      usernameIsExist: false,
      originalUsername: '',
      emailIsValid: false,

      // 邮箱在系统中已存在
      emailIsExist: false,
      originalEmail: '',
      userReset: {
        username: '',
        id: '',
        password: '',
        confirm_password: ''
      },
      addUserRules: {
        username: [{ required: false, validator: stringValidator }],
        email: [{ required: false, validator: emailValidator }],
        password: [{ required: true, validator: pwValidator }],
        confirm_password: [{ required: true, validator: pwConfirmValidator }]
      },
      resetPasswordRules: {
        password: [{ required: true, validator: pwValidator }],
        confirm_password: [{ required: true, validator: pwConfirmValidator }]
      }
    };
  },

  watch: {
    /* eslint-disable object-shorthand */
    'addUser.username': function addUserUsername(newVal, oldVal) {
      if (newVal && oldVal) {
        this.originalEmail = '';
        this.$refs.addForm.validateField('email');
      }
    },
    'addUser.email': function addUserEmail(newVal, oldVal) {
      if (newVal && oldVal) {
        this.originalUsername = '';
        this.$refs.addForm.validateField('username');
      }
    }
  },
  methods: {
    resetAdd: function resetAdd() {
      this.clearPassword();
      this.$refs.addForm.resetFields();
      this.usernameIsValid = false;
      this.usernameIsExist = false;
      this.emailIsValid = false;
      this.emailIsExist = false;
      this.originalUsername = '';
      this.originalEmail = '';
    },
    resetPasswordForm: function resetPasswordForm() {
      this.clearPassword();
      this.$refs.resetForm.resetFields();
    },
    resetResign: function resetResign() {
      this.resignForm.email = null;
      this.resign = false;
    },
    createRandomPassword: function createRandomPassword() {
      this.randomPassword = this.$utils.randomPassword();
      this.addUser.password = this.randomPassword;
      this.addUser.confirm_password = this.randomPassword;
      this.userReset.password = this.randomPassword;
      this.userReset.confirm_password = this.randomPassword;
    },
    clearPassword: function clearPassword() {
      this.randomPassword = '';
    },
    formatDatetime: function formatDatetime(r, c) {
      var ds = r[c.property];
      return ds ? this.$moment(ds).utcOffset(+960).format('YYYY/M/DD HH:mm:ss') : '';
    },
    joinAppsName: function joinAppsName(row) {
      return row.applications.map(function (app) {
        return app.name;
      }).join(',');
    },
    fetchHamletUsers: function fetchHamletUsers() {
      var _this2 = this;

      this.$api.fetchHamletUsers().then(function (res) {
        var cleaningRecords = [];
        for (var i = 0, len = res.data.users.length; i < len; i += 1) {
          var record = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.data.users[i]); // copy object. avoid vuex outside change error
          if (!record.is_active) {
            record.status = _this2.$t('pages.hamlet_users.inactive');
          } else if (record.is_locked) {
            record.status = _this2.$t('pages.hamlet_users.locked');
          } else if (!record.has_password) {
            record.status = _this2.$t('pages.hamlet_users.resigned');
          } else {
            record.status = _this2.$t('pages.hamlet_users.normal');
          }
          record.username = record.username || ''; // 方便搜索、排序  部分用户名字为空
          record.email = record.email || ''; // 方便搜索、排序
          cleaningRecords.push(record);
        }
        _this2.users = cleaningRecords;
      });
    },
    fetchApps: function fetchApps() {
      var _this3 = this;

      this.pageLoading = true;
      this.$api.listApps().then(function (res) {
        _this3.apps = res.data.applications;
      }).finally(function () {
        _this3.pageLoading = false;
      });
    },
    addHamletUser: function addHamletUser() {
      var _this4 = this;

      this.$api.addHamletUser(this.addUser).then(function (res) {
        _this4.add = false;
        _this4.fetchHamletUsers();
      }).catch(function (res) {
        console.log('res', res);
        _this4.$message.error(_this4.$t('common.addFailed'));
      });
    },
    resignHamletUser: function resignHamletUser() {
      var _this5 = this;

      this.$api.resignHamletUser(this.resignForm).then(function (res) {
        _this5.resign = false;
        _this5.fetchHamletUsers();
      }).catch(function (res) {
        console.log('res', res);
        _this5.$message.error(_this5.$t('common.ResignFailed'));
      });
    },
    authorizeAppManager: function authorizeAppManager() {
      var _this6 = this;

      this.$api.authorizeAppManager(this.userApps.id, {
        app_ids: this.userApps.app_ids
      }).then(function (res) {
        _this6.edit = false;
        _this6.fetchHamletUsers();
      });
    },
    changeUserPassword: function changeUserPassword() {
      var _this7 = this;

      this.$api.changeUserPassword(this.userReset.id, {
        password: this.userReset.password,
        confirm_password: this.userReset.confirm_password
      }).then(function (val) {
        _this7.reset = false;
        _this7.fetchHamletUsers();
      }).catch(function (res) {
        // console.log('>>>changeUserPassword failed>>>', res);
        _this7.$message.error(res.body.reason);
      });
    },
    editUserApps: function editUserApps(row) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.userApps, {
        id: row.id,
        username: row.username,
        app_ids: row.applications.map(function (app) {
          return app.id;
        })
      });
      this.edit = true;
    },
    editUser: function editUser(id, param) {
      var _this8 = this;

      this.$api.editUser(id, param).then(function (res) {
        _this8.fetchHamletUsers();
      });
    },
    unlockUser: function unlockUser(id) {
      var _this9 = this;

      this.$api.unlockUser(id).then(function (res) {
        _this9.fetchHamletUsers();
      });
    },
    resetPassword: function resetPassword(row) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.userReset, {
        username: row.username,
        id: row.id
      });
      this.reset = true;
    },
    submitAddUser: function submitAddUser() {
      var _this10 = this;

      this.$nextTick(function () {
        _this10.$refs.addForm.validate(function (validate) {
          if (validate) {
            _this10.$api.userIsExist({
              username: _this10.addUser.username,
              email: _this10.addUser.email
            }).then(function () {
              _this10.usernameIsExist = false;
              _this10.emailIsExist = false;
              _this10.$nextTick(function () {
                _this10.$refs.addForm.validate(function (validate) {
                  if (validate) {
                    _this10.addHamletUser();
                  }
                });
              });
            }).catch(function (res) {
              var data = res.body.data;
              _this10.$nextTick(function () {
                if ((!_this10.addUser.username || data.user.username === _this10.addUser.username) && (!_this10.addUser.email || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["b" /* compareIgnoreCase */])(data.user.email, _this10.addUser.email))) {
                  _this10.addHamletUser();
                }
              });
            });
          }
        });
      });
    },
    submitResetPassword: function submitResetPassword() {
      var _this11 = this;

      this.$refs.resetForm.validate(function (validate) {
        if (validate) {
          _this11.changeUserPassword();
        }
      });
    },
    openResignUserDialog: function openResignUserDialog(row) {
      this.resignForm.email = row.email;
      this.resign = true;
    },
    resignUser: function resignUser() {
      this.resignHamletUser();
    },
    unlockUserWithWarning: function unlockUserWithWarning(row) {
      var _this12 = this;

      this.$msgbox.confirm(this.$t('verify.unlock_user', { 'username': row.username }), this.$t('common.unlock'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel')
      }).then(function () {
        _this12.unlockUser(row.id);
      });
    },
    activeUser: function activeUser(row) {
      var _this13 = this;

      var message = row.is_active ? 'verify.forbid_user' : 'verify.active_user';
      var title = row.is_active ? 'common.forbid' : 'common.active';
      this.$msgbox.confirm(this.$t(message, { 'username': row.username }), this.$t(title), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel')
      }).then(function () {
        _this13.editUser(row.id, { is_active: !row.is_active });
      });
    },
    checkUsername: function checkUsername() {
      var _this14 = this;

      this.usernameIsValid = !!(this.addUser.username && !this.users.find(function (user) {
        return user.username === _this14.addUser.username;
      }));
      if (!this.usernameIsValid) {
        // this.originalUsername = '';
        this.originalEmail = '';
        this.usernameIsExist = false;
      }

      this.$refs.addForm.validateField('username');
      this.$refs.addForm.validateField('email');
      if (this.usernameIsValid) {
        this.$api.userIsExist({
          username: this.addUser.username
        }).then(function (val) {
          _this14.usernameIsExist = false;
          _this14.originalEmail = '';
        }).catch(function (res) {
          console.log('res', res.body.data);
          var data = res.body.data;

          // this.originalUsername = data.user.username;
          _this14.originalEmail = data.user.email;

          // 仅邮箱为空时，自动填充
          if (!_this14.addUser.email || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["b" /* compareIgnoreCase */])(data.user.email, _this14.addUser.email)) {
            _this14.addUser.email = data.user.email;
            _this14.emailIsValid = true;
            _this14.emailIsExist = true;
          }

          _this14.usernameIsExist = true;
        }).finally(function () {
          // this.$refs.addForm.validateField('email');
          _this14.$refs.addForm.validate();
        });
      }
    },
    checkEmail: function checkEmail() {
      var _this15 = this;

      this.emailIsValid = !!(this.addUser.email && this.emailRegexp.test(this.addUser.email) && !this.users.find(function (user) {
        return user.email === _this15.addUser.email;
      }));
      if (!this.emailIsValid) {
        // this.originalEmail = '';
        this.originalUsername = '';
        this.emailIsExist = false;
      }

      this.$refs.addForm.validateField('username');
      this.$refs.addForm.validateField('email');
      if (this.emailIsValid) {
        this.$api.userIsExist({
          email: this.addUser.email
        }).then(function () {
          _this15.emailIsExist = false;
          _this15.originalUsername = '';
        }).catch(function (res) {
          var data = res.body.data;

          _this15.originalUsername = data.user.username;
          // this.originalEmail = data.user.email;

          // 仅邮箱为空时，自动填充
          if (!_this15.addUser.username || data.user.username === _this15.addUser.username) {
            _this15.addUser.username = data.user.username;
            _this15.usernameIsValid = true;
            _this15.usernameIsExist = true;
          }

          _this15.emailIsExist = true;
        }).finally(function () {
          _this15.$refs.addForm.validate();
        });
      }
    }
  },
  created: function created() {
    this.fetchHamletUsers();
    this.fetchApps();
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
      form: {
        app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
        username: '',
        password: ''
      },
      weixinParam: {
        app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
        return_url: 'http://hamlet.yimian.com.cn/apps'
      },
      locked: false,
      forbid: false
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.$refs.form.validate(function (valid) {
        if (!_this.form.username || !_this.form.password) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_element_ui__["Message"])('请填写用户名和密码');
          return;
        }

        if (valid) {
          _this.$auth.login(_this.form).then(function () {
            _this.$router.push({ name: 'applications' });
          }).catch(function (res) {
            var _res$body = res.body,
                errCode = _res$body.err_code,
                reason = _res$body.reason;

            if (errCode && reason) {
              _this.$message.error(reason);
            } else {
              _this.$message.error('Unknown. Please contact an administrator');
            }
          });
        }
      });
    },
    loginByWeixin: function loginByWeixin() {
      var _this2 = this;

      this.$api.loginByWeixin(this.weixinParam).then(function (res) {
        window.location = res.data.url;
      }).catch(function (err) {
        _this2.$message.error(err.body.data);
      });
    },
    redirectForgotPassword: function redirectForgotPassword() {
      /* eslint-disable */
      var url = "https://hamlet.yimian.com.cn" + '/forgot_password?app_key=' + "qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi" + '&callback_url=' + document.location.href;
      window.location = url;
    }
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var d = new Date();
    var oneMonthAgo = d.setMonth(d.getMonth() - 1);
    return {
      allEvents: [],
      inputParam: {
        app_id: '',
        since: oneMonthAgo,
        until: new Date(),
        events: [],
        orderby: '-created_at',
        page: 1,
        count: 50
      },
      totalLogs: 0,
      pageSizes: [20, 50, 100],
      apps: [],
      logs: [],
      fetchLogsError: false
    };
  },

  computed: {
    searchParam: function searchParam() {
      var searchParam = {};
      if (this.inputParam.app_id) searchParam.app_id = parseInt(this.inputParam.app_id, 10);
      if (this.inputParam.events.length > 0) searchParam.events = this.inputParam.events.join(',');
      if (this.inputParam.since) {
        searchParam.since = parseInt(this.inputParam.since.valueOf() / 1000, 10);
      }
      if (this.inputParam.until) {
        searchParam.until = parseInt(this.inputParam.until.valueOf() / 1000, 10);
      }
      searchParam.page = this.inputParam.page;
      searchParam.count = this.inputParam.count;
      searchParam.orderby = this.inputParam.orderby;
      return searchParam;
    }
  },
  methods: {
    formatDatetime: function formatDatetime(r, c) {
      var ds = r[c.property];
      return ds ? this.$moment(ds).utcOffset(+960).format('YYYY/M/DD HH:mm:ss') : '';
    },
    searchLogs: function searchLogs() {
      var _this = this;

      this.fetchLogsError = false;
      this.$api.searchLogs(this.searchParam).then(function (res) {
        var pager = res.data.pager;
        _this.logs = res.data.logs;
        _this.totalLogs = pager.total;
      }).catch(function () {
        _this.fetchLogsError = true;
        _this.logs = [];
        _this.totalLogs = 0;
      });
    },
    fetchApps: function fetchApps() {
      var _this2 = this;

      this.$api.listApps().then(function (res) {
        _this2.apps = res.data.applications;
      });
    },
    fetchEvents: function fetchEvents() {
      var _this3 = this;

      this.$api.fetchEvents().then(function (res) {
        _this3.allEvents = res.data.events;
      });
    },
    handleSizeChange: function handleSizeChange(s) {
      this.searchParam.count = s;
      this.searchParam.page = 1;
      this.searchLogs();
    },
    handleCurrentChange: function handleCurrentChange(p) {
      this.searchParam.page = p;
      this.searchLogs();
    },
    sortChange: function sortChange(event) {
      var prop = event.prop;
      if (prop === 'username') prop = 'user_id';
      if (prop === 'app_name') prop = 'app_id';
      var order = event.order;
      var prefix = order === 'descending' ? '-' : '';
      this.searchParam.orderby = '' + prefix + prop;
      this.searchLogs();
    }
  },
  created: function created() {
    this.fetchEvents();
    this.fetchApps();
    this.searchLogs();
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var pwValidator = function pwValidator(rule, value, cb) {
      var ptn = _this.$consts.PASSWORD_REGEXP;
      if (value === '') {
        cb(new Error(_this.$t('common.passwordPlaceholder')));
      } else if (!ptn.test(value)) {
        cb(new Error(_this.$t('rules.password_format')));
      } else {
        cb();
      }
    };
    var pwConfirmValidator = function pwConfirmValidator(rule, value, cb) {
      if (value === '') {
        cb(new Error(_this.$t('common.confirmPasswordPlaceholder')));
      } else if (value !== _this.confirmForm.password) {
        cb(new Error(_this.$t('rules.password_repeat')));
      } else {
        cb();
      }
    };
    return {
      app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
      logo_url: null,
      resetParams: {
        email: '',
        app_name: '',
        app_url: ''
      },
      confirmForm: {
        email: null,
        username: null,
        password: null,
        confirmPassword: null
      },
      rules: {
        username: [{ required: true, message: this.$t('rules.username'), trigger: 'change' }],
        password: [{ required: true, validator: pwValidator, trigger: 'change' }],
        confirmPassword: [{ required: true, validator: pwConfirmValidator, trigger: 'change' }]
      },
      current_reset: '',
      password_error: false,
      forbid: false
    };
  },

  methods: {
    validateUrlQuery: function validateUrlQuery() {
      var query = this.$route.query;
      if (!query.app_key) {
        this.$message.error(this.$t('bind.invalid_app_key'));
      } else if (!query.token) {
        this.$message.error(this.$t('bind.invalid_token'));
      }
    },
    initQuery: function initQuery() {
      var _this2 = this;

      var args = this.$route.query;
      if (args) {
        var callbackParams = {
          client_app_key: args.app_key,
          token: args.token
        };
        this.$http.post('/api/auth/reset/callback', callbackParams).then(function (res) {
          console.log('res', res);
          if (res.body.ok) {
            _this2.updateConfirmParams(res.body.data);
            _this2.logo_url = res.body.data.logo_url;
          } else if (res.body.reason === 'invalid argument' && 'token' in res.body.data) {
            _this2.$message.error(_this2.$t('bind.invalid_token'));
          } else if (res.body.reason === 'invalid argument' && 'client_app_key' in res.body.data) {
            _this2.$message.error(_this2.$t('bind.invalid_app_key'));
          }
        });
      }
    },
    updateConfirmParams: function updateConfirmParams(data) {
      this.resetParams = data;
      if (this.$route.query.callback_url) {
        this.resetParams.app_url = this.$route.query.callback_url;
      }

      this.current_reset = data.mode;
      this.confirmForm.email = data.email;
      this.confirmForm.app_name = data.app_name;
      this.confirmForm.app_user_id = data.app_user_id;
      if (this.current_reset === 'need_bind_user') {
        this.$message.error(this.$t('reset.needBindUserErrorMessage'));
      }
    },
    confirmReset: function confirmReset() {
      var _this3 = this;

      var params = {
        client_app_key: this.$route.query.app_key,
        token: this.$route.query.token,
        password: this.confirmForm.password,
        confirm_password: this.confirmForm.confirmPassword,
        lang: localStorage.getItem('HAMLET_LANGUAGE')
      };
      this.$http.post('/api/auth/reset_password', params).then(function (res) {
        var body = res.body;
        // console.log('>>>confirmReset>>>res', res);

        if (body.ok) {
          _this3.$message.success(_this3.$t('reset.resetSuccessMessage'));
          _this3.current_reset = 'reset_password_success';
        } else if (body.reason === 'invalid username') {
          _this3.$message.error(_this3.$t('bind.existed_username'));
        } else if (body.reason === 'invalid argument') {
          if ('password' in body.data) {
            _this3.$message.error(_this3.$t('rules.password'));
          } else if ('confirm_password' in body.data) {
            _this3.$message.error(_this3.$t('rules.password_repeat'));
          }
        } else if (body.reason === 'not found') {
          _this3.$message.error(_this3.$t('bind.invalid_token'));
        } else if (body.err_code) {
          _this3.$message.error(body.reason);
        } else {
          _this3.$message.error(_this3.$t('pages.account.resetFail'));
        }
      }).catch(function (res) {
        // console.log('>>>confirmReset>>error>res', res);
        var body = res.body;
        var reason = body.reason;

        if (reason === 'not found') {
          _this3.$message.error(_this3.$t('bind.invalid_token'));
        } else if (body.err_code) {
          _this3.$message.error(reason);
        } else {
          _this3.$message.error(_this3.$t('pages.account.resetFail'));
        }
      });
    }
  },
  created: function created() {
    this.validateUrlQuery();
    this.initQuery();
  }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppLogo',
  props: {
    appName: {
      type: String,
      default: 'yimian'
    },
    appState: {
      type: String,
      default: ''
    },
    singLogo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      logos: ['yimian', 'hamlet', 'oneload', 'yisonar', 'oneview', 'yidrone', 'wechat']
    };
  },

  methods: {
    getImgSrc: function getImgSrc() {
      var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var logo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      /* eslint-disable */
      var src = null;

      if (logo) {
        app = this.logos.includes(app.toLocaleLowerCase()) ? app.toLocaleLowerCase() : 'default';
        app = 'logos/' + app;
      }

      try {
        src = __webpack_require__(398)("./" + app + '.svg');
      } catch (err) {
        src = __webpack_require__(218);
      }

      return src;
    }
  }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppLogo__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppLogo__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SmsLogin',
  components: {
    AppLogo: __WEBPACK_IMPORTED_MODULE_3__components_AppLogo___default.a
  },
  data: function data() {
    return {
      pageLoading: true,

      // 接收短信的电话号码
      tel: '',
      smsCode: '',
      appProfile: {},
      logo: '',
      urls: {
        home_url: "https://hamlet.yimian.com.cn" || 'https://hamlet.yimian.com.cn',
        appProfile: '/api/auth/apps/profile',
        verifySmsCode: '/api/auth/sms/verify/sms_code',
        sendSmsCode: '/api/auth/sms/send_sms'
      },
      time: 60,
      timer: null,
      confirming: false,
      needReLogin: false,
      tokens: {},
      params: {
        app_key: '',
        sms_type: 'login',
        lang: 'en',
        tel: ''
      }
    };
  },

  computed: {
    headers: function headers() {
      var query = this.$route.query;

      var token = query.tk || query.hamlet_tk;
      if (token) {
        return {
          Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token
        };
      }

      return {};
    }
  },
  created: function created() {
    var query = this.$route.query;

    if (!query.ak || !query.sk) {
      this.pageLoading = false;
      this.toReturnUrl();
    }

    this.params.tel = query.tel || '';
    this.params.app_key = query.ak;
    this.params.sms_token = query.sk;
    this.getAppProfile();

    if (query.lang) {
      this.params.lang = query.lang;
      if (this.$locale) {
        this.$locale.use(query.lang === 'en' ? 'en' : 'zh');
      }
    }

    this.initialTime();
  },
  beforeRouteLeave: function beforeRouteLeave() {
    clearInterval(this.timer);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    initialTime: function initialTime() {
      this.time = 60;
    },
    getAppProfile: function getAppProfile() {
      var _this = this;

      this.pageLoading = true;
      this.httpAxios(this.urls.appProfile, {
        app_key: this.params.app_key
      }, 'GET', this.headers).then(function (val) {
        _this.appProfile = val.data || {};
        _this.countDown();
      }).catch(function (err) {
        console.log('>>>>err\n', err);
        if (err.status === 401) {
          _this.toReturnUrl();
        }
      }).finally(function () {
        setTimeout(function () {
          _this.pageLoading = false;
        }, 600);
      });
    },
    httpAxios: function httpAxios(url, data) {
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
      var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var params = { method: method, url: url };

      if (method === 'GET') {
        params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(params, { params: data });
      } else {
        params.data = data;
      }

      if (headers) {
        params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(params, { headers: headers });
      }

      // console.log('>>>>>>params', params);
      return __WEBPACK_IMPORTED_MODULE_2_axios___default()(params).then(function (res) {
        if (res.data.ok) {
          return res.data;
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res.data);
      }).catch(function (err) {
        console.error('>>>http>>>err>>>\n', err);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err.response || err);
      });
    },
    getCode: function getCode() {
      var _this2 = this;

      this.httpAxios(this.urls.sendSmsCode, {
        app_key: this.params.app_key,
        sms_token: this.params.sms_token,
        lang: this.params.lang
      }, 'POST').then(function (val) {
        var data = val.data;
        // console.log('>>>sendSmsCode>>>val>>>>', val);

        _this2.params.sms_token = data.sms_token;
        _this2.initialTime();
        _this2.countDown();
      }).catch(function (err) {
        // console.log('>>>>sendSmsCode>>>err', err);
        var errCode = err.err_code;

        var reason = err.reason;

        if (errCode === '01C0705') {
          _this2.needReLogin = true;
        } else if (errCode === '01C0706') {
          var data = err.data;

          var message = data.sms_message ? data.sms_message.message : _this2.$t('common.contactAdmin');
          reason = reason + ': ' + message;
        }

        _this2.$message.error(reason);
      });
    },
    countDown: function countDown() {
      var _this3 = this;

      this.timer = setInterval(function () {
        _this3.time -= 1;
        if (_this3.time <= 0) {
          clearInterval(_this3.timer);
        }
      }, 1000);
    },
    verifySmsCode: function verifySmsCode() {
      var _this4 = this;

      this.confirming = true;
      var params = {
        app_key: this.params.app_key,
        sms_token: this.params.sms_token,
        sms_code: this.smsCode,
        lang: this.params.lang
      };
      this.httpAxios(this.urls.verifySmsCode, params, 'POST').then(function (val) {
        var data = val.data;

        // 验证码正确

        if (data.access_token) {
          _this4.tokens = data;
          _this4.enterApp();
        }
      }).catch(function (err) {
        console.log('>>>>verifySmsCode>>>err', err);
        var reason = err.reason;

        _this4.$message.error(reason);
      }).finally(function () {
        _this4.confirming = false;
      });
    },
    enterApp: function enterApp() {
      clearInterval(this.timer);
      var query = this.$route.query;
      var tokens = this.tokens;

      window.location = query.ru + '?thirdparty_connect_access_token=' + tokens.access_token + '&thirdparty_connect_refresh_token=' + tokens.refresh_token;
    },
    toReturnUrl: function toReturnUrl() {
      var query = this.$route.query;

      window.location = query.ru || query.a_ru || query.hamlet_a_ru || this.urls.home_url;
    }
  }
});

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 98,
	"./af.js": 98,
	"./ar": 105,
	"./ar-dz": 99,
	"./ar-dz.js": 99,
	"./ar-kw": 100,
	"./ar-kw.js": 100,
	"./ar-ly": 101,
	"./ar-ly.js": 101,
	"./ar-ma": 102,
	"./ar-ma.js": 102,
	"./ar-sa": 103,
	"./ar-sa.js": 103,
	"./ar-tn": 104,
	"./ar-tn.js": 104,
	"./ar.js": 105,
	"./az": 106,
	"./az.js": 106,
	"./be": 107,
	"./be.js": 107,
	"./bg": 108,
	"./bg.js": 108,
	"./bn": 109,
	"./bn.js": 109,
	"./bo": 110,
	"./bo.js": 110,
	"./br": 111,
	"./br.js": 111,
	"./bs": 112,
	"./bs.js": 112,
	"./ca": 113,
	"./ca.js": 113,
	"./cs": 114,
	"./cs.js": 114,
	"./cv": 115,
	"./cv.js": 115,
	"./cy": 116,
	"./cy.js": 116,
	"./da": 117,
	"./da.js": 117,
	"./de": 120,
	"./de-at": 118,
	"./de-at.js": 118,
	"./de-ch": 119,
	"./de-ch.js": 119,
	"./de.js": 120,
	"./dv": 121,
	"./dv.js": 121,
	"./el": 122,
	"./el.js": 122,
	"./en-au": 123,
	"./en-au.js": 123,
	"./en-ca": 124,
	"./en-ca.js": 124,
	"./en-gb": 125,
	"./en-gb.js": 125,
	"./en-ie": 126,
	"./en-ie.js": 126,
	"./en-nz": 127,
	"./en-nz.js": 127,
	"./eo": 128,
	"./eo.js": 128,
	"./es": 130,
	"./es-do": 129,
	"./es-do.js": 129,
	"./es.js": 130,
	"./et": 131,
	"./et.js": 131,
	"./eu": 132,
	"./eu.js": 132,
	"./fa": 133,
	"./fa.js": 133,
	"./fi": 134,
	"./fi.js": 134,
	"./fo": 135,
	"./fo.js": 135,
	"./fr": 138,
	"./fr-ca": 136,
	"./fr-ca.js": 136,
	"./fr-ch": 137,
	"./fr-ch.js": 137,
	"./fr.js": 138,
	"./fy": 139,
	"./fy.js": 139,
	"./gd": 140,
	"./gd.js": 140,
	"./gl": 141,
	"./gl.js": 141,
	"./gom-latn": 142,
	"./gom-latn.js": 142,
	"./he": 143,
	"./he.js": 143,
	"./hi": 144,
	"./hi.js": 144,
	"./hr": 145,
	"./hr.js": 145,
	"./hu": 146,
	"./hu.js": 146,
	"./hy-am": 147,
	"./hy-am.js": 147,
	"./id": 148,
	"./id.js": 148,
	"./is": 149,
	"./is.js": 149,
	"./it": 150,
	"./it.js": 150,
	"./ja": 151,
	"./ja.js": 151,
	"./jv": 152,
	"./jv.js": 152,
	"./ka": 153,
	"./ka.js": 153,
	"./kk": 154,
	"./kk.js": 154,
	"./km": 155,
	"./km.js": 155,
	"./kn": 156,
	"./kn.js": 156,
	"./ko": 157,
	"./ko.js": 157,
	"./ky": 158,
	"./ky.js": 158,
	"./lb": 159,
	"./lb.js": 159,
	"./lo": 160,
	"./lo.js": 160,
	"./lt": 161,
	"./lt.js": 161,
	"./lv": 162,
	"./lv.js": 162,
	"./me": 163,
	"./me.js": 163,
	"./mi": 164,
	"./mi.js": 164,
	"./mk": 165,
	"./mk.js": 165,
	"./ml": 166,
	"./ml.js": 166,
	"./mr": 167,
	"./mr.js": 167,
	"./ms": 169,
	"./ms-my": 168,
	"./ms-my.js": 168,
	"./ms.js": 169,
	"./my": 170,
	"./my.js": 170,
	"./nb": 171,
	"./nb.js": 171,
	"./ne": 172,
	"./ne.js": 172,
	"./nl": 174,
	"./nl-be": 173,
	"./nl-be.js": 173,
	"./nl.js": 174,
	"./nn": 175,
	"./nn.js": 175,
	"./pa-in": 176,
	"./pa-in.js": 176,
	"./pl": 177,
	"./pl.js": 177,
	"./pt": 179,
	"./pt-br": 178,
	"./pt-br.js": 178,
	"./pt.js": 179,
	"./ro": 180,
	"./ro.js": 180,
	"./ru": 181,
	"./ru.js": 181,
	"./sd": 182,
	"./sd.js": 182,
	"./se": 183,
	"./se.js": 183,
	"./si": 184,
	"./si.js": 184,
	"./sk": 185,
	"./sk.js": 185,
	"./sl": 186,
	"./sl.js": 186,
	"./sq": 187,
	"./sq.js": 187,
	"./sr": 189,
	"./sr-cyrl": 188,
	"./sr-cyrl.js": 188,
	"./sr.js": 189,
	"./ss": 190,
	"./ss.js": 190,
	"./sv": 191,
	"./sv.js": 191,
	"./sw": 192,
	"./sw.js": 192,
	"./ta": 193,
	"./ta.js": 193,
	"./te": 194,
	"./te.js": 194,
	"./tet": 195,
	"./tet.js": 195,
	"./th": 196,
	"./th.js": 196,
	"./tl-ph": 197,
	"./tl-ph.js": 197,
	"./tlh": 198,
	"./tlh.js": 198,
	"./tr": 199,
	"./tr.js": 199,
	"./tzl": 200,
	"./tzl.js": 200,
	"./tzm": 202,
	"./tzm-latn": 201,
	"./tzm-latn.js": 201,
	"./tzm.js": 202,
	"./uk": 203,
	"./uk.js": 203,
	"./ur": 204,
	"./ur.js": 204,
	"./uz": 206,
	"./uz-latn": 205,
	"./uz-latn.js": 205,
	"./uz.js": 206,
	"./vi": 207,
	"./vi.js": 207,
	"./x-pseudo": 208,
	"./x-pseudo.js": 208,
	"./yo": 209,
	"./yo.js": 209,
	"./zh-cn": 210,
	"./zh-cn.js": 210,
	"./zh-hk": 211,
	"./zh-hk.js": 211,
	"./zh-tw": 212,
	"./zh-tw.js": 212
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 358;

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export randomPassword */
/* harmony export (immutable) */ __webpack_exports__["c"] = getValueByPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = compare;
/* harmony export (immutable) */ __webpack_exports__["b"] = compareIgnoreCase;

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * 生成随机密码
 * @return {[type]} 随机密码字符串
 */
function _randomPassword() {
  var source = ['0123456789', 'abcdefghijklmnopqrstuvwxyz', 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', "!\"#$%&'()*+,-./:;<=>?@[]^_`{|}~"];
  var pswLength = random(8, 10);
  var psw = '';

  for (var i = 0; i < pswLength; i += 1) {
    var item = source[random(0, 2)];
    psw += item.charAt(random(0, item.length - 1));
  }

  for (var j = 0; j < 4; j += 1) {
    var charac = source[j].charAt(random(0, source[j].length - 1));
    var randomSplit = random(0, source[j].length - 1);
    psw = [psw.slice(0, randomSplit), charac, psw.slice(randomSplit)].join('');
  }

  return psw;
}

function getValueByPath(object, prop) {
  var paths = (prop || '').split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i += 1) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
}

function compare(a, b) {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b);
  }
  if (typeof a === 'boolean' && typeof b === 'boolean') {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    return 0;
  }
  if (typeof a === 'number' && typeof b === 'number') {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    return 0;
  }
  if (typeof a === 'number' && typeof b === 'string') {
    return -1;
  }
  if (typeof a === 'string' && typeof b === 'number') {
    return 1;
  }
  return 1;
}

function compareIgnoreCase(a, b) {
  if (!a && b || a && !b) {
    return 1;
  }

  var ta = typeof a === 'string' ? a.toLowerCase() : a;
  var tb = typeof b === 'string' ? b.toLowerCase() : b;

  return compare(ta, tb);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  randomPassword: function randomPassword() {
    return _randomPassword();
  }
});

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00NC45OTk2IDM3LjEwMDJDNDQuOTk5OCAzNy4xMDAyIDQ1IDM3LjEwMDIgNDUuMDAwMSAzNy4xMDAyQzQ1LjAyNDcgMzcuMTAwMyA0NS4wMjY0IDI4LjQ5NjQgNDUuMDA1MyAxMS4yODg3TDUxLjY2NjcgMTVWNDFMMjguMzMzMyA1NEw1IDQxTDUgMTVMMTEuNjY2NyAxMS4yODU3VjM3LjFMMjguMzMzMyA0Ni41MjVMNDQuOTk5NiAzNy4xMDAyWk0zOC4zNTI5IDMzLjE4NDlMMjguMzMzMyAzOC44NTFMMTguMzMzMyAzMy4xOTZWNy41NzE0M0wyOC4zMzMzIDJMMzguMzUyOSA3LjU4MjNWMzMuMTg0OVoiIGZpbGw9IiMxQzgwRTQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ny4yNDMzIDE3LjU4NzdMNTEuNjY2NyA0MUw0NSAzNy4xVjE4LjlWMTEuMUw1MS42NjY3IDE1TDQ3LjI0MzMgMTcuNTg3N1pNMTEuNjY2NyAxOC45VjM3LjFMNSA0MUw5LjQyMzM4IDE3LjU4NzdMNSAxNUwxMS42NjY3IDExLjFWMTguOVoiIGZpbGw9IiMwMDUyQTMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOC4zMzMxIDM4Ljg1MDlMMTguMzMzMSAzMy4xOTU5VjcuNTcxNDNMMjguMzMzMSAyVjM4Ljg1MDlaIiBmaWxsPSIjMEE2QkNDIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjguMzMzMSAyTDM4LjMzMzEgNy41MjVMMjguMzMzMSAxMy4wNUwxOC4zMzMxIDcuNTI1TDI4LjMzMzEgMloiIGZpbGw9IiMzMzk5RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOC4zMzMzIDQ2LjUyNUwxMS42NjY2IDM3LjFMNC45OTk5OCA0MUwyOC4zMzMzIDU0VjQ2LjUyNVoiIGZpbGw9IiMwQTZCQ0MiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODYiIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA4NiA4NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00MyA3LjE2NjY3QzYyLjc5MDIgNy4xNjY2NyA3OC44MzM0IDIzLjIwOTggNzguODMzNCA0M0M3OC44MzM0IDYyLjc5MDIgNjIuNzkwMiA3OC44MzMzIDQzIDc4LjgzMzNDMjMuMjA5OCA3OC44MzMzIDcuMTY2NjkgNjIuNzkwMiA3LjE2NjY5IDQzQzcuMTY2NjkgMjMuMjA5OCAyMy4yMDk4IDcuMTY2NjcgNDMgNy4xNjY2N1pNNTguODQ4MiAzMC42MDE3TDM4Ljc4NCA1MC42NjU5TDI4Ljg3MjkgNDAuNzU0OEwyNS4wODM0IDQ0LjU0NDNMMzYuMjU5MSA1NS43MjgxQzM2LjI1ODggNTUuNzI4NiAzNi4yNTkgNTUuNzI4NyAzNi4yNTkxIDU1LjcyODlMMzYuNDM4NCA1NS44OTY1QzM3Ljg0NTcgNTcuMTI2MSAzOS45ODUzIDU3LjA3MDcgNDEuMzI2MyA1NS43Mjk1TDYyLjY1NTYgMzQuNDA5MUw1OC44NDgyIDMwLjYwMTdaIiBmaWxsPSIjMDdDMTYwIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIHZpZXdCb3g9IjAgMCA3MiA3MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNi4wMDAyIDBDNTUuODgyNSAwIDcyLjAwMDIgMTYuMTE3NyA3Mi4wMDAyIDM2QzcyLjAwMDIgNTUuODgyMiA1NS44ODI1IDcyIDM2LjAwMDIgNzJDMTYuMTE4IDcyIDAuMDAwMjQ0MTQxIDU1Ljg4MjIgMC4wMDAyNDQxNDEgMzZDMC4wMDAyNDQxNDEgMTYuMTE3NyAxNi4xMTggMCAzNi4wMDAyIDBaTTM1Ljk4NDEgNDguMDE5OUMzNC4xODc2IDQ4LjAxOTkgMzIuNzYwMiA0OS4zOTggMzIuNzYwMiA1MS4xOTQ1QzMyLjc2MDIgNTIuOTkxIDM0LjE4NzYgNTQuMzY5MSAzNS45ODQxIDU0LjM2OTFDMzcuODI5OCA1NC4zNjkxIDM5LjIzMjUgNTIuOTkxIDM5LjIzMjUgNTEuMTk0NUMzOS4yMzI1IDQ5LjM5OCAzNy44Mjk4IDQ4LjAxOTkgMzUuOTg0MSA0OC4wMTk5Wk0zOC43NDAzIDE0Ljg4ODdIMzMuMjUyNEwzMy42NDYyIDQyLjIzNjdIMzguMzQ2NkwzOC43NDAzIDE0Ljg4ODdaIiBmaWxsPSIjRkE1MTUxIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(388),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(386),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(380),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(391),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-997fad2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(385),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(382),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(383),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(392),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(381),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 380:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }]
  }, [(_vm.currentApp) ? _c('el-row', {
    staticClass: "content-top"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('pages.hamlet_users.select_app')) + "\n    "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.currentApp),
      callback: function($$v) {
        _vm.currentApp = $$v
      },
      expression: "currentApp"
    }
  }, _vm._l((_vm.apps), function(app) {
    return _c('el-option', {
      key: app.name,
      attrs: {
        "label": app.name,
        "value": app
      }
    }, [_vm._v("\n        " + _vm._s(app.name) + "\n      ")])
  }), 1), _vm._v(" "), (_vm.currentApp.allow_create_user) ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toCreateUser
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("\n      " + _vm._s(_vm.$t('pages.hamlet_users.add_user')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "page-toolbar__group--right"
  }, [_c('el-input', {
    attrs: {
      "icon": "search",
      "placeholder": _vm.$t('pages.hamlet_users.searchPlaceholder')
    },
    model: {
      value: (_vm.tableCfg.search),
      callback: function($$v) {
        _vm.$set(_vm.tableCfg, "search", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "tableCfg.search"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.currentUsers,
      "default-sort": {
        prop: 'id',
        order: 'ascending'
      }
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "100",
      "sortable": "custom",
      "label": _vm.$t('pages.hamlet_users.id')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "width": "130",
      "sortable": "custom",
      "label": _vm.$t('pages.hamlet_users.username')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "min-width": "150",
      "sortable": "custom",
      "label": _vm.$t('pages.hamlet_users.email')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "width": "100",
      "label": _vm.$t('pages.hamlet_users.role')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_login_at",
      "width": "160",
      "align": "center",
      "label": _vm.$t('pages.hamlet_users.last_login_at'),
      "formatter": _vm.formatDatetime
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "width": "120",
      "align": "center",
      "label": _vm.$t('pages.hamlet_users.status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.status) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thirdparty_users",
      "min-width": "100",
      "label": _vm.$t('pages.hamlet_users.thirdparty_users')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((Object.keys(scope.row.thirdparty_users)), function(type) {
          return _c('div', {
            key: type
          }, [_c('el-popover', {
            attrs: {
              "placement": "right",
              "trigger": "click"
            }
          }, [_c('el-button', {
            key: type,
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_vm._v("\n                " + _vm._s(_vm.$t(("common." + type))) + "\n              ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(scope.row.thirdparty_users[type]))])], 1), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.toUnbindUserAccount(scope.row, type)
              }
            }
          }, [_vm._v("解绑")])], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "100",
      "align": "center",
      "label": _vm.$t('common.operation')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.resetPassword(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.resetPassword')) + "\n          ")]), _vm._v(" "), (scope.row.is_active) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.popUpEditUserDialog(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.edit')) + "\n          ")]) : _vm._e(), _vm._v(" "), (scope.row.is_active) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.activeUser(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.forbid')) + "\n          ")]) : _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.activeUser(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.active')) + "\n          ")]), _vm._v(" "), (scope.row.is_locked && scope.row.is_active) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.unlockUser(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.unlock')) + "\n          ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "table-wrapper__pagination",
    attrs: {
      "layout": "sizes, total, prev, pager, next",
      "page-sizes": _vm.tableCfg.pageSizes,
      "total": _vm.usersTotal
    },
    on: {
      "current-change": _vm.handleUsersCurPageChange,
      "size-change": _vm.handleUsersSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('common.edit')
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editUserForm,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.username')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.editUserForm.username) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.email'),
      "prop": "email"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.editUserForm.email) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.role')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editUserForm.role),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "role", $$v)
      },
      expression: "editUserForm.role"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.tel')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editUserForm.tel),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "tel", $$v)
      },
      expression: "editUserForm.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.forceLoginSms')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.editUserForm.force_sms),
      callback: function($$v) {
        _vm.$set(_vm.editUserForm, "force_sms", $$v)
      },
      expression: "editUserForm.force_sms"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitEditUser
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.currentApp && _vm.currentApp.allow_create_user) ? _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pages.hamlet_users.add_user')
    },
    on: {
      "close": _vm.resetAdd
    },
    model: {
      value: (_vm.add),
      callback: function($$v) {
        _vm.add = $$v
      },
      expression: "add"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addUser,
      "rules": _vm.addUserRules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.app_name')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currentApp.name) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.username'),
      "prop": "username"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.checkUsername
    },
    model: {
      value: (_vm.addUser.username),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "username", $$v)
      },
      expression: "addUser.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.email'),
      "prop": "email"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.checkEmail
    },
    model: {
      value: (_vm.addUser.email),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "email", $$v)
      },
      expression: "addUser.email"
    }
  })], 1), _vm._v(" "), (!_vm.usernameIsExist && !_vm.emailIsExist) ? [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.role'),
      "prop": "role"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addUser.role),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "role", $$v)
      },
      expression: "addUser.role"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.addUser.password),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "password", $$v)
      },
      expression: "addUser.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.random_password')) + "\n          ")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.randomPassword))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitAddUser($event)
      }
    },
    model: {
      value: (_vm.addUser.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "confirm_password", $$v)
      },
      expression: "addUser.confirm_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.tel')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.addUser.tel),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "tel", $$v)
      },
      expression: "addUser.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.forceLoginSms')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.addUser.force_sms),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "force_sms", $$v)
      },
      expression: "addUser.force_sms"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "disabled": !this.addUser.username && !this.addUser.email,
      "type": "primary"
    },
    on: {
      "click": _vm.submitAddUser
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-resetpsw",
    attrs: {
      "title": _vm.$t('common.resetPassword')
    },
    on: {
      "close": _vm.clearResetform
    },
    model: {
      value: (_vm.reset),
      callback: function($$v) {
        _vm.reset = $$v
      },
      expression: "reset"
    }
  }, [_c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.userReset,
      "rules": _vm.resetPasswordRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.username'),
      "prop": "username"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.userReset.username) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "password", $$v)
      },
      expression: "userReset.password"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.random_password')) + "\n          ")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.randomPassword))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitResetPassword($event)
      }
    },
    model: {
      value: (_vm.userReset.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "confirm_password", $$v)
      },
      expression: "userReset.confirm_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitResetPassword
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "p-bind container"
  }, [_c('el-row', {
    staticClass: "login-wrap"
  }, [_c('el-row', {
    staticClass: "bind-con"
  }, [_c('el-row', {
    staticClass: "bind-header"
  }, [_c('el-row', {
    staticClass: "bind-logo"
  }, [(_vm.logo_url) ? [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo_url,
      "alt": "",
      "width": "60px"
    }
  })] : [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(28),
      "alt": "",
      "width": "60px"
    }
  })]], 2), _vm._v(" "), (_vm.current_reset === 'reset_password') ? [_c('h2', [_vm._v(_vm._s(_vm.$t('reset.resetPasswordTitle')))])] : _vm._e()], 2), _vm._v(" "), _c('el-row', {
    staticClass: "bind-content"
  }, [(_vm.current_reset === 'reset_password_success') ? _c('el-row', [_c('span', {
    staticClass: "bind-success"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bind-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('reset.reset_success_html', {
        app_name: _vm.resetParams.app_name,
        email: _vm.resetParams.email,
        app_url: _vm.resetParams.app_url
      }))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.current_reset === 'reset_password') ? _c('el-row', [_c('el-form', {
    ref: "confirmForm",
    staticClass: "bind-form",
    attrs: {
      "model": _vm.confirmForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "app_name",
      "label": _vm.$t('common.application')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.confirmForm.app_name),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "app_name", $$v)
      },
      expression: "confirmForm.app_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('common.email')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.confirmForm.email),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "email", $$v)
      },
      expression: "confirmForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": _vm.$t('reset.newPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('reset.newPasswordPlaceholder')
    },
    model: {
      value: (_vm.confirmForm.password),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "password", $$v)
      },
      expression: "confirmForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "prop": "confirmPassword",
      "label": _vm.$t('reset.confirmNewPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('reset.confirmNewPasswordPlaceholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmReset($event)
      }
    },
    model: {
      value: (_vm.confirmForm.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "confirmPassword", $$v)
      },
      expression: "confirmForm.confirmPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bind-btns"
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmReset
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.resetPassword')) + "\n                ")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "p-bind container"
  }, [_c('el-row', {
    staticClass: "login-wrap"
  }, [_c('el-row', {
    staticClass: "bind-con"
  }, [_c('el-row', {
    staticClass: "bind-header"
  }, [_c('el-row', {
    staticClass: "bind-logo"
  }, [(_vm.logo_url) ? [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo_url,
      "alt": "",
      "width": "60px"
    }
  })] : [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(28),
      "alt": "",
      "width": "60px"
    }
  })]], 2), _vm._v(" "), [_c('h2', [_vm._v(_vm._s(_vm.$t('pages.forgot_password.forgotPasswordTitle')))])]], 2), _vm._v(" "), _c('el-row', {
    staticClass: "bind-content"
  }, [(_vm.current_reset === 'reset_password_checked') ? _c('el-row', [_c('span', {
    staticClass: "bind-success"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bind-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('reset.email_sent_info_html', {
        app_name: this.confirmForm.app_name,
        email: this.confirmForm.email
      }))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.current_reset === 'reset_password') ? _c('el-row', [_c('el-form', {
    ref: "confirmForm",
    staticClass: "bind-form",
    attrs: {
      "model": _vm.confirmForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "app_name",
      "label": _vm.$t('common.application')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.confirmForm.app_name),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "app_name", $$v)
      },
      expression: "confirmForm.app_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('common.email')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('pages.forgot_password.emailPlaceholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmRecover($event)
      }
    },
    model: {
      value: (_vm.confirmForm.email),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "email", $$v)
      },
      expression: "confirmForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bind-btns"
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmRecover
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.sendResetPasswordEmail')) + "\n                ")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "p-login container"
  }, [_c('el-row', {
    staticClass: "login-wrap"
  }, [_c('el-row', {
    staticClass: "login-con"
  }, [_c('el-row', {
    staticClass: "login-logo"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(28),
      "alt": "",
      "width": "72px"
    }
  })]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "login-form",
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('common.usernamePlaceholder')
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('common.passwordPlaceholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.login')) + "\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "large",
      "type": "text"
    },
    on: {
      "click": _vm.loginByWeixin
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('pages.login.WeixinLogin')) + "\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "large",
      "type": "text"
    },
    on: {
      "click": _vm.redirectForgotPassword
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('pages.login.ForgotPassword')) + "\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "content-top"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.add = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("\n      " + _vm._s(_vm.$t('pages.hamlet_users.add_user')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.resign = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("\n      " + _vm._s(_vm.$t('pages.hamlet_users.add_resign_user')) + "\n    ")])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }]
  }, [_c('el-table', {
    attrs: {
      "data": _vm.users
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "100",
      "label": _vm.$t('pages.hamlet_users.id')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "width": "130",
      "label": _vm.$t('pages.hamlet_users.username')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "min-width": "150",
      "label": _vm.$t('pages.hamlet_users.email')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "label": _vm.$t('pages.hamlet_users.applications'),
      "formatter": _vm.joinAppsName
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_login_at",
      "width": "160",
      "align": "center",
      "label": _vm.$t('pages.hamlet_users.last_login_at'),
      "formatter": _vm.formatDatetime
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "width": "120",
      "align": "center",
      "label": _vm.$t('pages.hamlet_users.status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.status) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thirdparty_users",
      "min-width": "100",
      "label": _vm.$t('pages.hamlet_users.thirdparty_users')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((Object.keys(scope.row.thirdparty_users)), function(type) {
          return _c('el-popover', {
            key: type,
            attrs: {
              "placement": "right",
              "trigger": "click"
            }
          }, [_c('el-button', {
            key: type,
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_vm._v("\n              " + _vm._s(_vm.$t('common.' + type)) + "\n            ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(scope.row.thirdparty_users[type]))])], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('common.operation'),
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editUserApps(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.edit')) + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.resetPassword(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.resetPassword')) + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.activeUser(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t(("common." + (scope.row.is_active ? 'forbid' : 'active')))) + "\n          ")]), _vm._v(" "), (scope.row.is_locked) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.unlockUser(scope.row.id)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('common.unlock')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": !scope.row.has_password
          },
          on: {
            "click": function($event) {
              return _vm.openResignUserDialog(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('pages.hamlet_users.resign_user')) + "\n          ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('common.edit')
    },
    model: {
      value: (_vm.edit),
      callback: function($$v) {
        _vm.edit = $$v
      },
      expression: "edit"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.userApps,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.username')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.userApps.username) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.hamlet_users.applications')
    }
  }, [(_vm.apps.length) ? _c('el-checkbox-group', {
    model: {
      value: (_vm.userApps.app_ids),
      callback: function($$v) {
        _vm.$set(_vm.userApps, "app_ids", $$v)
      },
      expression: "userApps.app_ids"
    }
  }, _vm._l((_vm.apps), function(app) {
    return (app.name !== 'Hamlet') ? _c('el-checkbox', {
      key: app.id,
      attrs: {
        "label": app.id
      }
    }, [_vm._v("\n            " + _vm._s(app.name) + "\n          ")]) : _vm._e()
  }), 1) : _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('pages.hamlet_users.no_apps')) + "\n        ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.authorizeAppManager
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pages.hamlet_users.add_user')
    },
    on: {
      "close": _vm.resetAdd
    },
    model: {
      value: (_vm.add),
      callback: function($$v) {
        _vm.add = $$v
      },
      expression: "add"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addUser,
      "rules": _vm.addUserRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.username'),
      "prop": "username"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.checkUsername
    },
    model: {
      value: (_vm.addUser.username),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "username", $$v)
      },
      expression: "addUser.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.email'),
      "prop": "email"
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.checkEmail
    },
    model: {
      value: (_vm.addUser.email),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "email", $$v)
      },
      expression: "addUser.email"
    }
  })], 1), _vm._v(" "), (!_vm.usernameIsExist && !_vm.emailIsExist) ? [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addUser.password),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "password", $$v)
      },
      expression: "addUser.password"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.random_password')) + "\n              ")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.randomPassword))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitAddUser($event)
      }
    },
    model: {
      value: (_vm.addUser.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.addUser, "confirm_password", $$v)
      },
      expression: "addUser.confirm_password"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "disabled": !this.addUser.username && !this.addUser.email,
      "type": "primary"
    },
    on: {
      "click": _vm.submitAddUser
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('common.resetPassword')
    },
    on: {
      "close": _vm.resetPasswordForm
    },
    model: {
      value: (_vm.reset),
      callback: function($$v) {
        _vm.reset = $$v
      },
      expression: "reset"
    }
  }, [_c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.userReset,
      "rules": _vm.resetPasswordRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.username'),
      "prop": "username"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.userReset.username) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "password", $$v)
      },
      expression: "userReset.password"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.random_password')) + "\n          ")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.randomPassword))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitResetPassword($event)
      }
    },
    model: {
      value: (_vm.userReset.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "confirm_password", $$v)
      },
      expression: "userReset.confirm_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitResetPassword
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.save')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pages.hamlet_users.add_resign_user')
    },
    on: {
      "close": _vm.resetResign
    },
    model: {
      value: (_vm.resign),
      callback: function($$v) {
        _vm.resign = $$v
      },
      expression: "resign"
    }
  }, [_c('el-form', {
    ref: "resignForm",
    attrs: {
      "model": _vm.resignForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.email'),
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.resignForm.email),
      callback: function($$v) {
        _vm.$set(_vm.resignForm, "email", $$v)
      },
      expression: "resignForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.resignUser
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.confirm')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "p-bind container"
  }, [_c('el-row', {
    staticClass: "login-wrap"
  }, [_c('el-row', {
    staticClass: "bind-con"
  }, [_c('el-row', {
    staticClass: "bind-header"
  }, [_c('el-row', {
    staticClass: "bind-logo"
  }, [(_vm.logo_url) ? [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo_url,
      "alt": "",
      "width": "60px"
    }
  })] : [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(28),
      "alt": "",
      "width": "60px"
    }
  })]], 2), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('bind.page.title')))]), _vm._v(" "), (_vm.current_bind != 'bind_user') ? _c('p', {
    staticClass: "bind-text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('bind.page.description')) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "bind-content"
  }, [(_vm.current_bind == 'bind_user') ? _c('el-row', [_c('span', {
    staticClass: "bind-success"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bind-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('bind.bind_html', this.bindParams))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.current_bind == 'old_user') ? _c('el-row', [_c('el-form', {
    ref: "confirmForm",
    staticClass: "bind-form",
    attrs: {
      "model": _vm.confirmForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "app_name",
      "label": _vm.$t('common.application')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.confirmForm.app_name),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "app_name", $$v)
      },
      expression: "confirmForm.app_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('common.email')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.confirmForm.email),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "email", $$v)
      },
      expression: "confirmForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bind-btns"
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmBind
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.bind')) + "\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.current_bind == 'new_user') ? _c('el-row', [_c('el-form', {
    ref: "confirmForm",
    staticClass: "bind-form",
    attrs: {
      "model": _vm.confirmForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "app_name",
      "label": _vm.$t('common.application')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.confirmForm.app_name),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "app_name", $$v)
      },
      expression: "confirmForm.app_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('common.email')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.confirmForm.email),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "email", $$v)
      },
      expression: "confirmForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": _vm.$t('common.username')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('common.usernamePlaceholder')
    },
    model: {
      value: (_vm.confirmForm.username),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "confirmForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": _vm.$t('common.password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('common.passwordPlaceholder'),
      "readonly": _vm.readOnlyFlag
    },
    on: {
      "focus": function($event) {
        _vm.readOnlyFlag = false;
      }
    },
    model: {
      value: (_vm.confirmForm.password),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "password", $$v)
      },
      expression: "confirmForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "confirmPassword",
      "label": _vm.$t('common.confirmPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('common.confirmPasswordPlaceholder'),
      "readonly": _vm.readOnlyFlag
    },
    on: {
      "focus": function($event) {
        _vm.readOnlyFlag = false;
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmBind($event)
      }
    },
    model: {
      value: (_vm.confirmForm.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.confirmForm, "confirmPassword", $$v)
      },
      expression: "confirmForm.confirmPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bind-btns"
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmBind
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.bind')) + "\n                ")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-appmanage"
  }, [_c('el-row', {
    staticClass: "content-title"
  }, [_c('h2', {
    staticClass: "txt-gray"
  }, [_vm._v(_vm._s(_vm.$t('pages.apps.name')) + " : " + _vm._s(_vm.basicInfo.name))])]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('pages.apps.basic'),
      "name": "basic"
    }
  }, [_c('el-form', {
    ref: "basicForm",
    attrs: {
      "model": _vm.basicInfo,
      "rules": _vm.basicFromRule,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.basicInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "name", $$v)
      },
      expression: "basicInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.description'),
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.basicInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "description", $$v)
      },
      expression: "basicInfo.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.base_url'),
      "prop": "base_url"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.basicInfo.base_url),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "base_url", $$v)
      },
      expression: "basicInfo.base_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.status'),
      "prop": "is_active"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.active')
    },
    model: {
      value: (_vm.basicInfo.is_active),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "is_active", $$v)
      },
      expression: "basicInfo.is_active"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.allow_create_user'),
      "prop": "allow_create_user"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.allow')
    },
    model: {
      value: (_vm.basicInfo.allow_create_user),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "allow_create_user", $$v)
      },
      expression: "basicInfo.allow_create_user"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateApp
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('pages.apps.registration_settings'),
      "name": "configure"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.authSetting,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "allow_register",
      "label": _vm.$t('pages.appSetting.allow_register')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.allow_register),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "allow_register", $$v)
      },
      expression: "authSetting.allow_register"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "verify_email",
      "label": _vm.$t('pages.appSetting.need_verify_email')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.verify_email),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "verify_email", $$v)
      },
      expression: "authSetting.verify_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "verify_email_callback",
      "label": _vm.$t('pages.appSetting.verify_email_callback')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.verify_email_callback),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "verify_email_callback", $$v)
      },
      expression: "authSetting.verify_email_callback"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password_pattern",
      "label": _vm.$t('pages.appSetting.password_pattern')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.password_pattern),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "password_pattern", $$v)
      },
      expression: "authSetting.password_pattern"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password_description",
      "label": _vm.$t('pages.appSetting.password_description')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.password_description),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "password_description", $$v)
      },
      expression: "authSetting.password_description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "reset_password_callback",
      "label": _vm.$t('pages.appSetting.reset_password_callback')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.reset_password_callback),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "reset_password_callback", $$v)
      },
      expression: "authSetting.reset_password_callback"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateAuth
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('pages.apps.login_settings'),
      "name": "login"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.authSetting,
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "allow_weixin_login",
      "label": _vm.$t('pages.appSetting.allow_weixin_login')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.allow_weixin_login),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "allow_weixin_login", $$v)
      },
      expression: "authSetting.allow_weixin_login"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "force_weixin_login",
      "label": _vm.$t('pages.appSetting.force_weixin_login')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.force_weixin_login),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "force_weixin_login", $$v)
      },
      expression: "authSetting.force_weixin_login"
    }
  })], 1), _vm._v(" "), (_vm.authSetting.force_weixin_login) ? _c('el-form-item', {
    attrs: {
      "prop": "ignore_weixin_login",
      "label": _vm.$t('pages.appSetting.ignore_weixin_login')
    }
  }, [_vm._l((_vm.authSetting.ignore_weixin_login || []), function(tag) {
    return _c('el-tag', {
      key: tag,
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "closable": true,
        "close-transition": false,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag) + "\n          ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticStyle: {
      "width": "160px",
      "vertical-align": "bottom"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ New Role")])], 2) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "login_by_email",
      "label": _vm.$t('pages.appSetting.login_by_email')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.login_by_email),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "login_by_email", $$v)
      },
      expression: "authSetting.login_by_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "login_lock",
      "label": _vm.$t('pages.appSetting.login_lock')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.login_lock),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "login_lock", $$v)
      },
      expression: "authSetting.login_lock"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "login_max_attempts",
      "label": _vm.$t('pages.appSetting.login_max_attempts')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.login_max_attempts),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "login_max_attempts", $$v)
      },
      expression: "authSetting.login_max_attempts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "access_token_expiration",
      "label": _vm.$t('pages.appSetting.access_token_expiration')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.access_token_expiration),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "access_token_expiration", $$v)
      },
      expression: "authSetting.access_token_expiration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "refresh_token_expiration",
      "label": _vm.$t('pages.appSetting.refresh_token_expiration')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.refresh_token_expiration),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "refresh_token_expiration", $$v)
      },
      expression: "authSetting.refresh_token_expiration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "need_login_sms",
      "label": _vm.$t('pages.appSetting.need_login_sms')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.need_login_sms),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "need_login_sms", $$v)
      },
      expression: "authSetting.need_login_sms"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password_limit_reuse",
      "label": _vm.$t('pages.appSetting.password_limit_reuse')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.password_limit_reuse),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "password_limit_reuse", $$v)
      },
      expression: "authSetting.password_limit_reuse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password_expiration",
      "label": _vm.$t('pages.appSetting.password_expiration')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.password_expiration),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "password_expiration", $$v)
      },
      expression: "authSetting.password_expiration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "revoke_on_logout",
      "label": _vm.$t('pages.appSetting.revoke_on_logout')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.revoke_on_logout),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "revoke_on_logout", $$v)
      },
      expression: "authSetting.revoke_on_logout"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "revoke_on_change_pwd",
      "label": _vm.$t('pages.appSetting.revoke_on_change_pwd')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.revoke_on_change_pwd),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "revoke_on_change_pwd", $$v)
      },
      expression: "authSetting.revoke_on_change_pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateAuth
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "email-template",
    attrs: {
      "label": _vm.$t('pages.apps.email_template'),
      "name": "email"
    }
  }, [_vm._l((_vm.emailTemplates), function(template, index) {
    return [_c('el-row', {
      key: index
    }, [_c('h4', {
      staticClass: "txt-gray"
    }, [_vm._v(_vm._s(_vm.$t(("pages.appSetting." + (template.name)))))])]), _vm._v(" "), _c('el-form', {
      key: index,
      attrs: {
        "model": template,
        "label-width": "140px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('pages.appSetting.type')
      }
    }, [_vm._v("\n            " + _vm._s(template.subject) + "\n          ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('pages.appSetting.content')
      }
    }, [_c('code', [_vm._v(_vm._s(template.body))])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('pages.appSetting.preview')
      }
    }, [_c('div', {
      staticClass: "view-block",
      domProps: {
        "innerHTML": _vm._s(_vm.formatEmail(template.body))
      }
    })]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editEmailTemplate(template)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.edit')))])], 1)], 1)]
  })], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('pages.apps.email_server'),
      "name": "server"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.smtpSetting,
      "rules": _vm.smptRules,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "host",
      "label": _vm.$t('pages.appSetting.host')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.smtpSetting.host),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "host", $$v)
      },
      expression: "smtpSetting.host"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "port",
      "label": _vm.$t('pages.appSetting.port')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.smtpSetting.port),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "port", $$v)
      },
      expression: "smtpSetting.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": _vm.$t('common.username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.smtpSetting.username),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "username", $$v)
      },
      expression: "smtpSetting.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": _vm.$t('common.password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.smtpSetting.password),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "password", $$v)
      },
      expression: "smtpSetting.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "use_ssl",
      "label": _vm.$t('pages.appSetting.use_ssl')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.smtpSetting.use_ssl),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "use_ssl", $$v)
      },
      expression: "smtpSetting.use_ssl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "use_tls",
      "label": _vm.$t('pages.appSetting.use_tls')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.smtpSetting.use_tls),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "use_tls", $$v)
      },
      expression: "smtpSetting.use_tls"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "fromname",
      "label": _vm.$t('pages.appSetting.fromname')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.smtpSetting.fromname),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "fromname", $$v)
      },
      expression: "smtpSetting.fromname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateSmtp
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pages.appSetting.verify_email')
    },
    model: {
      value: (_vm.editEmail),
      callback: function($$v) {
        _vm.editEmail = $$v
      },
      expression: "editEmail"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.emailTemplate,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "subject",
      "label": _vm.$t('pages.appSetting.type')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.emailTemplate.subject),
      callback: function($$v) {
        _vm.$set(_vm.emailTemplate, "subject", $$v)
      },
      expression: "emailTemplate.subject"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "body",
      "label": _vm.$t('pages.appSetting.content')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": _vm.rows
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateEmailTemplate($event)
      }
    },
    model: {
      value: (_vm.emailTemplate.body),
      callback: function($$v) {
        _vm.$set(_vm.emailTemplate, "body", $$v)
      },
      expression: "emailTemplate.body"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tips-danger"
  }, [_vm._v(_vm._s(_vm.$t('pages.appSetting.email_notify')))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateEmailTemplate
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }],
    staticClass: "bind-wrapper"
  }, [_c('div', {
    staticClass: "acConnect"
  }, [(_vm.appProfile.name) ? _c('app-logo', {
    staticStyle: {
      "margin-bottom": "2rem"
    },
    attrs: {
      "app-name": _vm.appProfile.name ? _vm.appProfile.name.toLocaleLowerCase() : '',
      "singLogo": true
    }
  }, [_c('span', {
    staticClass: "ml-4 acConnect__title"
  }, [_vm._v(_vm._s(_vm.appProfile.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "acConnect__text"
  }, [(!_vm.needReLogin) ? _c('span', {
    staticClass: "acConnect__text-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('thirdPartyLogin.codeHasBeenSentTo')) + " " + _vm._s(_vm.params.tel) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "acConnect__text-descr"
  }, [_c('el-input', {
    ref: "inputRef",
    attrs: {
      "maxlength": 4,
      "disabled": _vm.needReLogin,
      "autofocus": "",
      "clearable": "",
      "placeholder": _vm.$t('thirdPartyLogin.enterVerifyCode')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.verifySmsCode($event)
      }
    },
    model: {
      value: (_vm.smsCode),
      callback: function($$v) {
        _vm.smsCode = $$v
      },
      expression: "smsCode"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "disabled": !!_vm.time || _vm.needReLogin
    },
    on: {
      "click": function($event) {
        return _vm.getCode()
      }
    },
    slot: "append"
  }, [_vm._v("\n            " + _vm._s(_vm.time ? _vm.$t('thirdPartyLogin.getCodeAgain') : _vm.$t('thirdPartyLogin.getCode')) + "\n            "), (_vm.time) ? _c('span', [_vm._v("(" + _vm._s(_vm.time) + ")")]) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "acConnect__btns"
  }, [(_vm.needReLogin) ? _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "type": "warning"
    },
    on: {
      "click": _vm.toReturnUrl
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('thirdPartyLogin.needRelogin')) + "\n      ")]) : _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "type": "primary",
      "disabled": !_vm.smsCode || _vm.smsCode.length < 4 || _vm.confirming
    },
    on: {
      "click": _vm.verifySmsCode
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.login')) + "\n      ")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-reset"
  }, [(_vm.changed) ? _c('el-form', [_vm._v("\n    " + _vm._s(_vm.$t('pages.account.resetSuccess')) + "\n    "), _c('el-button', {
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.account.back_to_login')))])], 1) : _c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.userReset,
      "rules": _vm.resetPasswordRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.oldPassword'),
      "prop": "current_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.current_password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "current_password", $$v)
      },
      expression: "userReset.current_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "password", $$v)
      },
      expression: "userReset.password"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.random_password')))]), _vm._v(" "), _c('code', [_vm._v(_vm._s(_vm.randomPassword))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "confirm_password", $$v)
      },
      expression: "userReset.confirm_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitResetPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('common.resetPassword')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acConnect__imgs"
  }, [_c('div', {
    staticClass: "acConnect__imgs-item"
  }, [(_vm.singLogo) ? _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.appName, true),
      "alt": _vm.appName,
      "width": "48"
    }
  }) : (_vm.appState) ? _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.appState, false),
      "alt": _vm.appState,
      "width": "48"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(217),
      "alt": "WeChat",
      "width": "48"
    }
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (!_vm.singLogo && !_vm.appState) ? [_c('img', {
    staticClass: "acConnect__imgs-arrow",
    attrs: {
      "src": __webpack_require__(215)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acConnect__imgs-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.appName),
      "alt": _vm.appName,
      "width": "45"
    }
  })])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }],
    staticClass: "bind-wrapper"
  }, [_c('div', {
    staticClass: "acConnect"
  }, [(!_vm.successfullyBound && !_vm.applyUnbinding) ? [_c('app-logo', {
    attrs: {
      "app-name": _vm.bindInfo.app_name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acConnect__text"
  }, [_c('h1', {
    staticClass: "acConnect__text-title"
  }, [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.successfulLogin')))]), _vm._v(" "), _c('p', {
    staticClass: "acConnect__text-descr"
  }, [_vm._v("\n          " + _vm._s(_vm.$t(("thirdPartyLogin." + (_vm.isForceWeixinLogin ? 'needWeChat' : 'recommendWeChat')), {
    app: _vm.bindInfo.app_name
  })) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "acConnect__btns"
  }, [_c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "loading": _vm.binding,
      "type": "primary"
    },
    on: {
      "click": _vm.toBindWx
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isMiniprogram ? _vm.$t('thirdPartyLogin.bind') : _vm.$t('thirdPartyLogin.completeBinding')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "acConnect__btns-cancel"
  }, [(_vm.isMiniprogram) ? _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "disabled": _vm.binding,
      "plain": ""
    },
    on: {
      "click": _vm.toLoginPage
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))]) : _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.toReturnUrl
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isForceWeixinLogin ? _vm.$t('thirdPartyLogin.logout') : _vm.$t('thirdPartyLogin.doNotRemindAgain')) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "acConnect__btns-cancelDescr"
  }, [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.unbindPrompt')))])], 1)], 1)] : (_vm.applyUnbinding) ? [_c('app-logo', {
    attrs: {
      "app-state": _vm.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acConnect__text"
  }, [_c('h1', {
    staticClass: "acConnect__text-title"
  }, [_vm._v("\n          " + _vm._s(_vm.logo === 'warning' ? _vm.$t('thirdPartyLogin.applyForUnbinding') : _vm.$t('thirdPartyLogin.submittedUnbinding')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "acConnect__text-descr"
  }, [(_vm.logo === 'warning') ? [_vm._v("\n            " + _vm._s(_vm.$t('thirdPartyLogin.isUnbindWeChat')) + "\n            "), _c('div', [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.willNotLoginWithWeChat')))])] : [_vm._v("\n            " + _vm._s(_vm.$t('thirdPartyLogin.unbindingDesc')) + "\n            "), _c('div', [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.enterApp', {
    time: _vm.time
  })))])]], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.unbindLoading && _vm.logo === 'warning'),
      expression: "unbindLoading && logo === 'warning'"
    }],
    staticClass: "acConnect__btns"
  }, [(_vm.logo === 'warning') ? _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.toReturnUrl
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.cancel')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "acConnect__btns-cancel"
  }, [(_vm.logo === 'warning') ? _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": _vm.unbindAccount
    }
  }, [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.unbind')))]) : _c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.enterApp
    }
  }, [_vm._v(_vm._s(_vm.$t('thirdPartyLogin.backHome')))])], 1)], 1)] : [_c('app-logo', {
    attrs: {
      "app-state": 'success'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acConnect__text"
  }, [_c('h1', {
    staticClass: "acConnect__text-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('thirdPartyLogin.bindSuccessfully')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "acConnect__text-descr"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('thirdPartyLogin.boundDescription', {
    username: _vm.bindInfo.username,
    weixin: _vm.getNickname()
  })) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('thirdPartyLogin.enterApp', {
    time: _vm.time
  })) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "acConnect__btns"
  }, [_c('el-button', {
    staticClass: "acConnect__btns-item",
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.enterApp
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('thirdPartyLogin.enterImmediately')) + "\n        ")])], 1)]], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "content-top"
  }, [(_vm.$auth.user().role === 'root') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.add = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("\n      " + _vm._s(_vm.$t('pages.apps.addApp')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "right",
      "width": "260px"
    },
    attrs: {
      "placeholder": _vm.$t('pages.apps.enter_app_name'),
      "icon": "search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.filteredApps
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "80",
      "label": _vm.$t('pages.apps.id')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "140",
      "label": _vm.$t('pages.apps.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": _vm.$t('pages.apps.description')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "160",
      "lable": _vm.$t('pages.apps.app_key')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "code"
        }, [_vm._v("App Key: "), _c('span', [_vm._v(_vm._s(scope.row.app_key))])]), _vm._v(" "), _c('p', {
          staticClass: "code"
        }, [_vm._v("App Secret: "), _c('span', [_vm._v(_vm._s(scope.row.app_secret))])]), _vm._v(" "), _c('p', {
          staticClass: "code"
        }, [_vm._v("Api Key: "), _c('span', [_vm._v(_vm._s(scope.row.api_key))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "align": "center",
      "label": _vm.$t('pages.apps.is_active')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_active) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _c('i', {
          staticClass: "el-icon-close"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "label": _vm.$t('common.operation')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.manageApp(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('pages.apps.manage')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pages.apps.addApp')
    },
    on: {
      "close": _vm.resetAdd
    },
    model: {
      value: (_vm.add),
      callback: function($$v) {
        _vm.add = $$v
      },
      expression: "add"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.appForm,
      "rules": _vm.addFromRule,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('pages.apps.name')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.appForm.name),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "name", $$v)
      },
      expression: "appForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.base_url'),
      "prop": "base_url"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.appForm.base_url),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "base_url", $$v)
      },
      expression: "appForm.base_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "description",
      "label": _vm.$t('pages.apps.description')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addApp($event)
      }
    },
    model: {
      value: (_vm.appForm.description),
      callback: function($$v) {
        _vm.$set(_vm.appForm, "description", $$v)
      },
      expression: "appForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addApp
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('el-form', {
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.logs.selectApp')
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.inputParam.app_id),
      callback: function($$v) {
        _vm.$set(_vm.inputParam, "app_id", $$v)
      },
      expression: "inputParam.app_id"
    }
  }, _vm._l((_vm.apps), function(app) {
    return _c('el-option', {
      key: app.id,
      attrs: {
        "value": app.id,
        "label": app.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.logs.selectEvent')
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: (_vm.inputParam.events),
      callback: function($$v) {
        _vm.$set(_vm.inputParam, "events", $$v)
      },
      expression: "inputParam.events"
    }
  }, _vm._l((_vm.allEvents), function(event) {
    return _c('el-option', {
      key: event,
      attrs: {
        "value": event,
        "label": event
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.logs.timeRange')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": _vm.$t('pages.logs.startDate')
    },
    model: {
      value: (_vm.inputParam.since),
      callback: function($$v) {
        _vm.$set(_vm.inputParam, "since", $$v)
      },
      expression: "inputParam.since"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('common.to')) + " ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "placeholder": _vm.$t('pages.logs.endDate')
    },
    model: {
      value: (_vm.inputParam.until),
      callback: function($$v) {
        _vm.$set(_vm.inputParam, "until", $$v)
      },
      expression: "inputParam.until"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchLogs
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.logs.search')))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.logs,
      "default-sort": {
        prop: 'created_at',
        order: 'descending'
      }
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [(!_vm.fetchLogsError) ? [_c('span', [_vm._v("暂无数据")])] : [_c('span', [_vm._v("加载失败，请点击")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.searchLogs
    }
  }, [_vm._v("重试")])]], 2), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "100",
      "label": _vm.$t('pages.logs.id'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "label": _vm.$t('pages.logs.app_name'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": _vm.$t('pages.logs.username'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "event",
      "min-width": "120",
      "label": _vm.$t('pages.logs.event')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "extra",
      "label": _vm.$t('pages.logs.extra'),
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(Object.keys(scope.row.extra).length !== 0) ? _c('pre', {
          staticStyle: {
            "word-wrap": "break-word",
            "white-space": "pre-wrap"
          }
        }, [_vm._v(_vm._s(scope.row.extra))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ip",
      "min-width": "120",
      "label": _vm.$t('pages.logs.ip'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": _vm.$t('pages.logs.created_at'),
      "sortable": "custom",
      "formatter": _vm.formatDatetime,
      "width": "160",
      "align": "center"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.inputParam.count,
      "current-page": _vm.inputParam.page,
      "layout": "sizes, prev, pager, next",
      "total": _vm.totalLogs
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "wrapper"
  }, [(!_vm.$route.meta.hidden || _vm.$route.name === 'reset') ? [(_vm.$auth.ready()) ? [_c('header', {
    staticClass: "header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "Hamlet",
      "src": __webpack_require__(216),
      "height": "32px;"
    }
  })]), _vm._v(" "), _c('el-row', {
    staticClass: "user-info"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('span', {
    staticClass: "avatar"
  }, [_c('i', {
    staticClass: "iconfont icon-user"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$auth.user().username))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "db-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.resetPassword($event)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-user-tie el-icon--left"
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.resetPassword')) + "\n              ")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-exit el-icon--left"
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.logout')) + "\n              ")]), _vm._v(" "), (!_vm.$auth.user().thirdparty_users.weixin) ? _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.loginByWeixin($event)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-exit el-icon--left"
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.bound_weixin')) + "\n              ")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container"
  }, [_c('aside', {
    staticClass: "menu-wrapper"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical",
    attrs: {
      "default-active": _vm.activeMenu,
      "theme": "dark",
      "router": "",
      "unique-opened": ""
    }
  }, [_vm._l((_vm.$router.options.routes[1].children), function(route, index) {
    return [(!route.meta.hidden && _vm.roleShow(route)) ? _c('el-menu-item', {
      class: {
        'is-active': route.name === _vm.activeMenu || route.name === 'applications' && _vm.$route.name === 'app_manage'
      },
      attrs: {
        "index": route.name,
        "route": route
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t(("menu." + (route.name)))) + "\n              ")]) : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)] : _vm._e()] : _c('router-view')], 2)
},staticRenderFns: []}

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrows-horizontal.svg": 215,
	"./font/iconfont.svg": 360,
	"./logo-yimian.svg": 28,
	"./logo.svg": 216,
	"./logos/oneview.svg": 361,
	"./logos/wechat.svg": 217,
	"./logos/yidrone.svg": 362,
	"./logos/yimian.svg": 218,
	"./success.svg": 363,
	"./warning.svg": 364
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 398;

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[271]);


// WEBPACK FOOTER //
// static/js/app.31202868e487f4554113.js